/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as msRest from "@azure/ms-rest-js";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as Parameters from "./models/parameters";
import { ApiContext } from "./apiContext";
var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    /**
     * Initializes a new instance of the Api class.
     * @param [options] The parameter options
     */
    function Api(options) {
        return _super.call(this, options) || this;
    }
    Api.prototype.createCustomerAcceptedTerm = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerAcceptedTermOperationSpec, callback);
    };
    Api.prototype.updateAccountsMyChangePassword = function (xTenantContext, loginString, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            loginString: loginString,
            options: options
        }, updateAccountsMyChangePasswordOperationSpec, callback);
    };
    Api.prototype.getAccountsMy = function (xTenantContext, loginString, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            loginString: loginString,
            options: options
        }, getAccountsMyOperationSpec, callback);
    };
    Api.prototype.createAccountsMySendTemporaryPassword = function (xTenantContext, loginString, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            loginString: loginString,
            options: options
        }, createAccountsMySendTemporaryPasswordOperationSpec, callback);
    };
    Api.prototype.updateAccountsMyResetPassword = function (xTenantContext, loginString, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            loginString: loginString,
            options: options
        }, updateAccountsMyResetPasswordOperationSpec, callback);
    };
    Api.prototype.getAccountsChangePasswordMetadata = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getAccountsChangePasswordMetadataOperationSpec, callback);
    };
    Api.prototype.getAccountsMyPermissions = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getAccountsMyPermissionsOperationSpec, callback);
    };
    Api.prototype.updateCustomerActivationRequest = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerActivationRequestOperationSpec, callback);
    };
    Api.prototype.getCustomerAddresses = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerAddressesOperationSpec, callback);
    };
    Api.prototype.createCustomerAddress = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerAddressOperationSpec, callback);
    };
    Api.prototype.updateCustomerAddress = function (xTenantContext, customerId, addressId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            addressId: addressId,
            options: options
        }, updateCustomerAddressOperationSpec, callback);
    };
    Api.prototype.deleteCustomerAddress = function (xTenantContext, customerId, addressId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            addressId: addressId,
            options: options
        }, deleteCustomerAddressOperationSpec, callback);
    };
    Api.prototype.getCustomerAddressesMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerAddressesMetadataOperationSpec, callback);
    };
    Api.prototype.getAddressFormats = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getAddressFormatsOperationSpec, callback);
    };
    Api.prototype.getAddressFormat = function (xTenantContext, type, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            type: type,
            options: options
        }, getAddressFormatOperationSpec, callback);
    };
    Api.prototype.getPaymentPaymentProvidersAdyenPaymentMethods = function (xTenantContext, onlinePaymentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            onlinePaymentId: onlinePaymentId,
            options: options
        }, getPaymentPaymentProvidersAdyenPaymentMethodsOperationSpec, callback);
    };
    Api.prototype.createPaymentPaymentProvidersAdyenPayment = function (xTenantContext, onlinePaymentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            onlinePaymentId: onlinePaymentId,
            options: options
        }, createPaymentPaymentProvidersAdyenPaymentOperationSpec, callback);
    };
    Api.prototype.createPaymentPaymentProvidersAdyenPaymentDetail = function (xTenantContext, onlinePaymentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            onlinePaymentId: onlinePaymentId,
            options: options
        }, createPaymentPaymentProvidersAdyenPaymentDetailOperationSpec, callback);
    };
    Api.prototype.getPaymentPaymentProvidersAdyenClientCredentials = function (xTenantContext, onlinePaymentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            onlinePaymentId: onlinePaymentId,
            options: options
        }, getPaymentPaymentProvidersAdyenClientCredentialsOperationSpec, callback);
    };
    Api.prototype.createCustomerPaymentProvidersAdyenContractDisableRequest = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerPaymentProvidersAdyenContractDisableRequestOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationAnalytics = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, getCustomerRegistrationAnalyticsOperationSpec, callback);
    };
    Api.prototype.getCustomerApproval = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerApprovalOperationSpec, callback);
    };
    Api.prototype.updateCustomerApproval = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerApprovalMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerApprovalMetadataOperationSpec, callback);
    };
    Api.prototype.getAtpClusterAtp = function (xTenantContext, atpClusterId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            atpClusterId: atpClusterId,
            itemCode: itemCode,
            options: options
        }, getAtpClusterAtpOperationSpec, callback);
    };
    Api.prototype.getAtpClusterAtps = function (xTenantContext, atpClusterId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            atpClusterId: atpClusterId,
            options: options
        }, getAtpClusterAtpsOperationSpec, callback);
    };
    Api.prototype.getAtpCluster = function (xTenantContext, atpClusterId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            atpClusterId: atpClusterId,
            options: options
        }, getAtpClusterOperationSpec, callback);
    };
    Api.prototype.getAtpClusters = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getAtpClustersOperationSpec, callback);
    };
    Api.prototype.getCustomerAutoshipConfiguration = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerAutoshipConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerAutoshipAvailabilities = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerAutoshipAvailabilitiesOperationSpec, callback);
    };
    Api.prototype.getCustomerAutoshipTypes = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerAutoshipTypesOperationSpec, callback);
    };
    Api.prototype.getCustomerAutoshipLegalArticles = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerAutoshipLegalArticlesOperationSpec, callback);
    };
    Api.prototype.createCustomerAutoshipInstruction = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerAutoshipInstructionOperationSpec, callback);
    };
    Api.prototype.getConceptAvailability = function (xTenantContext, conceptCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            conceptCode: conceptCode,
            options: options
        }, getConceptAvailabilityOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptsAvailabilities = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerConceptsAvailabilitiesOperationSpec, callback);
    };
    Api.prototype.getConceptsAvailabilities = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getConceptsAvailabilitiesOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptAvailability = function (xTenantContext, customerId, conceptCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            conceptCode: conceptCode,
            options: options
        }, getCustomerConceptAvailabilityOperationSpec, callback);
    };
    Api.prototype.getCustomerProductAvailability = function (xTenantContext, customerId, productCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productCode: productCode,
            options: options
        }, getCustomerProductAvailabilityOperationSpec, callback);
    };
    Api.prototype.getProductAvailability = function (xTenantContext, productCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCode: productCode,
            options: options
        }, getProductAvailabilityOperationSpec, callback);
    };
    Api.prototype.getProductsAvailability = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getProductsAvailabilityOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsAvailability = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProductsAvailabilityOperationSpec, callback);
    };
    Api.prototype.getBackInStockNotifications = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getBackInStockNotificationsOperationSpec, callback);
    };
    Api.prototype.createBackInStockNotificationSubscription = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createBackInStockNotificationSubscriptionOperationSpec, callback);
    };
    Api.prototype.getBackInStockNotificationsConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getBackInStockNotificationsConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerBackInStockNotifications = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerBackInStockNotificationsOperationSpec, callback);
    };
    Api.prototype.createCustomerBackInStockNotificationSubscription = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerBackInStockNotificationSubscriptionOperationSpec, callback);
    };
    Api.prototype.getCustomerBankAccountApprovals = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerBankAccountApprovalsOperationSpec, callback);
    };
    Api.prototype.getCustomerBankAccounts = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerBankAccountsOperationSpec, callback);
    };
    Api.prototype.createCustomerBankAccount = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerBankAccountOperationSpec, callback);
    };
    Api.prototype.updateCustomerBankAccount = function (xTenantContext, customerId, bankAccountId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            bankAccountId: bankAccountId,
            options: options
        }, updateCustomerBankAccountOperationSpec, callback);
    };
    Api.prototype.deleteCustomerBankAccount = function (xTenantContext, customerId, bankAccountId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            bankAccountId: bankAccountId,
            options: options
        }, deleteCustomerBankAccountOperationSpec, callback);
    };
    Api.prototype.getCustomerBankAccountsMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerBankAccountsMetadataOperationSpec, callback);
    };
    Api.prototype.createCustomerBankAccountAuthorizationRequest = function (xTenantContext, customerId, bankAccountId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            bankAccountId: bankAccountId,
            options: options
        }, createCustomerBankAccountAuthorizationRequestOperationSpec, callback);
    };
    Api.prototype.getBankBranches = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getBankBranchesOperationSpec, callback);
    };
    Api.prototype.getBankBranch = function (xTenantContext, bankBranchId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            bankBranchId: bankBranchId,
            options: options
        }, getBankBranchOperationSpec, callback);
    };
    Api.prototype.getBanks = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getBanksOperationSpec, callback);
    };
    Api.prototype.getBank = function (xTenantContext, bankId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            bankId: bankId,
            options: options
        }, getBankOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionBasketOffer = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, createShoppingSessionBasketOfferOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionBasketOffer = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, updateShoppingSessionBasketOfferOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionBasketOffers = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionBasketOffersOperationSpec, callback);
    };
    Api.prototype.getBlockingCodes = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getBlockingCodesOperationSpec, callback);
    };
    Api.prototype.getCustomerBlockings = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerBlockingsOperationSpec, callback);
    };
    Api.prototype.deleteCustomerBlocking = function (xTenantContext, customerId, blockingId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            blockingId: blockingId,
            options: options
        }, deleteCustomerBlockingOperationSpec, callback);
    };
    Api.prototype.getCustomerBranch = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerBranchOperationSpec, callback);
    };
    Api.prototype.updateCustomerBranch = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerBranchOperationSpec, callback);
    };
    Api.prototype.getCustomerBranchMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerBranchMetadataOperationSpec, callback);
    };
    Api.prototype.getBranches = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getBranchesOperationSpec, callback);
    };
    Api.prototype.getBranch = function (xTenantContext, branchId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            branchId: branchId,
            options: options
        }, getBranchOperationSpec, callback);
    };
    Api.prototype.getBrands = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getBrandsOperationSpec, callback);
    };
    Api.prototype.createCallInteraction = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createCallInteractionOperationSpec, callback);
    };
    Api.prototype.getCampaignPoints = function (xTenantContext, campaignId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            campaignId: campaignId,
            options: options
        }, getCampaignPointsOperationSpec, callback);
    };
    Api.prototype.getCampaignRecruitPoints = function (xTenantContext, campaignId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            campaignId: campaignId,
            options: options
        }, getCampaignRecruitPointsOperationSpec, callback);
    };
    Api.prototype.getCampaigns = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getCampaignsOperationSpec, callback);
    };
    Api.prototype.getCampaign = function (xTenantContext, campaignId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            campaignId: campaignId,
            options: options
        }, getCampaignOperationSpec, callback);
    };
    Api.prototype.getCampaignsWelcomeProgramTargets = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getCampaignsWelcomeProgramTargetsOperationSpec, callback);
    };
    Api.prototype.getCampaignsWelcomeProgramBenefits = function (xTenantContext, step, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            step: step,
            options: options
        }, getCampaignsWelcomeProgramBenefitsOperationSpec, callback);
    };
    Api.prototype.getCampaignsActivityProgramTargets = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getCampaignsActivityProgramTargetsOperationSpec, callback);
    };
    Api.prototype.getCustomerCampaignBenefits = function (xTenantContext, customerId, campaignType, productCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            campaignType: campaignType,
            productCodes: productCodes,
            options: options
        }, getCustomerCampaignBenefitsOperationSpec, callback);
    };
    Api.prototype.getCustomerReportsCampaignPointsByOrders = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerReportsCampaignPointsByOrdersOperationSpec, callback);
    };
    Api.prototype.getCataloguesCatalogueContent = function (xTenantContext, catalogueCode, catalogueCode1, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            catalogueCode: catalogueCode,
            catalogueCode1: catalogueCode1,
            options: options
        }, getCataloguesCatalogueContentOperationSpec, callback);
    };
    Api.prototype.getApplicationsCatalogueIPaperCustomerConfiguration = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getApplicationsCatalogueIPaperCustomerConfigurationOperationSpec, callback);
    };
    Api.prototype.getCatalogueCatalogueItem = function (xTenantContext, catalogueId, catalogueItemId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            catalogueId: catalogueId,
            catalogueItemId: catalogueItemId,
            options: options
        }, getCatalogueCatalogueItemOperationSpec, callback);
    };
    Api.prototype.getCatalogueCatalogueItems = function (xTenantContext, catalogueId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            catalogueId: catalogueId,
            options: options
        }, getCatalogueCatalogueItemsOperationSpec, callback);
    };
    Api.prototype.getCatalogueOffers = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getCatalogueOffersOperationSpec, callback);
    };
    Api.prototype.getCataloguesDeprecated = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getCataloguesDeprecatedOperationSpec, callback);
    };
    Api.prototype.getSocialMediaLibraryCategory = function (xTenantContext, categoryId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            categoryId: categoryId,
            options: options
        }, getSocialMediaLibraryCategoryOperationSpec, callback);
    };
    Api.prototype.getSocialMediaLibraryCategories = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getSocialMediaLibraryCategoriesOperationSpec, callback);
    };
    Api.prototype.getCategories = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getCategoriesOperationSpec, callback);
    };
    Api.prototype.getApplicationsChatBotConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsChatBotConfigurationOperationSpec, callback);
    };
    Api.prototype.getApplicationsClaimsSpaCatalogueItemsSearch = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsClaimsSpaCatalogueItemsSearchOperationSpec, callback);
    };
    Api.prototype.getConceptLabels = function (xTenantContext, conceptCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            conceptCodes: conceptCodes,
            options: options
        }, getConceptLabelsOperationSpec, callback);
    };
    Api.prototype.getConcepts = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getConceptsOperationSpec, callback);
    };
    Api.prototype.getConcept = function (xTenantContext, conceptCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            conceptCode: conceptCode,
            options: options
        }, getConceptOperationSpec, callback);
    };
    Api.prototype.createApplicationsConcernReportForm = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createApplicationsConcernReportFormOperationSpec, callback);
    };
    Api.prototype.getApplicationsSocialMediaLibraryConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsSocialMediaLibraryConfigurationOperationSpec, callback);
    };
    Api.prototype.createCustomerConfirmation = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerConfirmationOperationSpec, callback);
    };
    Api.prototype.getLoginProvidersWeChatExternalAccountConnectedUser = function (xTenantContext, unionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            unionId: unionId,
            options: options
        }, getLoginProvidersWeChatExternalAccountConnectedUserOperationSpec, callback);
    };
    Api.prototype.getConsultantTitles = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getConsultantTitlesOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationContactDetails = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, getCustomerRegistrationContactDetailsOperationSpec, callback);
    };
    Api.prototype.updateCustomerRegistrationContactDetails = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, updateCustomerRegistrationContactDetailsOperationSpec, callback);
    };
    Api.prototype.createCustomerRegistrationContactDetailsConfirmation = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, createCustomerRegistrationContactDetailsConfirmationOperationSpec, callback);
    };
    Api.prototype.getConsultantCustomerId = function (xTenantContext, consultantNumber, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            consultantNumber: consultantNumber,
            options: options
        }, getConsultantCustomerIdOperationSpec, callback);
    };
    Api.prototype.getCustomerConsultantNumber = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerConsultantNumberOperationSpec, callback);
    };
    Api.prototype.getCustomerConsultantNumberDeprecated = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerConsultantNumberDeprecatedOperationSpec, callback);
    };
    Api.prototype.getConsultantCustomerIdDeprecated = function (xTenantContext, consultantNumber, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            consultantNumber: consultantNumber,
            options: options
        }, getConsultantCustomerIdDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptLabels = function (xTenantContext, customerId, conceptCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            conceptCodes: conceptCodes,
            options: options
        }, getCustomerConceptLabelsOperationSpec, callback);
    };
    Api.prototype.getCustomerInfo = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerInfoOperationSpec, callback);
    };
    Api.prototype.getCustomerInfoMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerInfoMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerWelcomeProgram = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerWelcomeProgramOperationSpec, callback);
    };
    Api.prototype.getCustomerActivityProgram = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerActivityProgramOperationSpec, callback);
    };
    Api.prototype.getCustomerRecruitmentCampaign = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerRecruitmentCampaignOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalSales = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPersonalSalesOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalSalesHistory = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPersonalSalesHistoryOperationSpec, callback);
    };
    Api.prototype.getCustomerLoyaltyProgram = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerLoyaltyProgramOperationSpec, callback);
    };
    Api.prototype.getCustomerMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerMetadataOperationSpec, callback);
    };
    Api.prototype.createCustomerNewsletterSubscription = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerNewsletterSubscriptionOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsLabels = function (xTenantContext, customerId, productCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productCodes: productCodes,
            options: options
        }, getCustomerProductsLabelsOperationSpec, callback);
    };
    Api.prototype.getCustomerRequiredTerms = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerRequiredTermsOperationSpec, callback);
    };
    Api.prototype.createReportsCustomerStatus = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createReportsCustomerStatusOperationSpec, callback);
    };
    Api.prototype.getCustomerCustomerStatus = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerCustomerStatusOperationSpec, callback);
    };
    Api.prototype.updateCustomerCustomerStatus = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerCustomerStatusOperationSpec, callback);
    };
    Api.prototype.getCustomerCustomerStatusMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerCustomerStatusMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerLocalConsultantTitle = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerLocalConsultantTitleOperationSpec, callback);
    };
    Api.prototype.getDigitalDocuments = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getDigitalDocumentsOperationSpec, callback);
    };
    Api.prototype.getDigitalDocument = function (xTenantContext, id, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            id: id,
            options: options
        }, getDigitalDocumentOperationSpec, callback);
    };
    Api.prototype.getDigitalDocumentContent = function (xTenantContext, id, contentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            id: id,
            contentId: contentId,
            options: options
        }, getDigitalDocumentContentOperationSpec, callback);
    };
    Api.prototype.getDigitalDocumentLatestContent = function (xTenantContext, id, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            id: id,
            options: options
        }, getDigitalDocumentLatestContentOperationSpec, callback);
    };
    Api.prototype.getCustomerDeliveryAddress = function (xTenantContext, customerId, deliveryAddressId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            deliveryAddressId: deliveryAddressId,
            options: options
        }, getCustomerDeliveryAddressOperationSpec, callback);
    };
    Api.prototype.getDeliveryChannel = function (xTenantContext, deliveryChannelId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            deliveryChannelId: deliveryChannelId,
            options: options
        }, getDeliveryChannelOperationSpec, callback);
    };
    Api.prototype.getDeliveryChannelAddress = function (xTenantContext, deliveryChannelId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            deliveryChannelId: deliveryChannelId,
            options: options
        }, getDeliveryChannelAddressOperationSpec, callback);
    };
    Api.prototype.getDeliveryChannelCoordinates = function (xTenantContext, deliveryChannelId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            deliveryChannelId: deliveryChannelId,
            options: options
        }, getDeliveryChannelCoordinatesOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDeliveryChannels = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionDeliveryChannelsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionClusteredPickupPoints = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionClusteredPickupPointsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDeliveryChannel = function (xTenantContext, sessionId, deliveryChannelId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            deliveryChannelId: deliveryChannelId,
            options: options
        }, getShoppingSessionDeliveryChannelOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDeliveryMethods = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionDeliveryMethodsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDeliveryFilters = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionDeliveryFiltersOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDeliveryOptions = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionDeliveryOptionsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDelivery = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionDeliveryOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionDelivery = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, updateShoppingSessionDeliveryOperationSpec, callback);
    };
    Api.prototype.createCourierWayBillNumberDeliveryStatus = function (xTenantContext, courierId, wayBillNumber, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            courierId: courierId,
            wayBillNumber: wayBillNumber,
            options: options
        }, createCourierWayBillNumberDeliveryStatusOperationSpec, callback);
    };
    Api.prototype.createCustomerDocument = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerDocumentOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentImage = function (xTenantContext, customerId, documentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            documentId: documentId,
            options: options
        }, getCustomerDocumentImageOperationSpec, callback);
    };
    Api.prototype.getCustomerDocument = function (xTenantContext, customerId, documentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            documentId: documentId,
            options: options
        }, getCustomerDocumentOperationSpec, callback);
    };
    Api.prototype.deleteCustomerDocument = function (xTenantContext, customerId, documentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            documentId: documentId,
            options: options
        }, deleteCustomerDocumentOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentsInfos = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerDocumentsInfosOperationSpec, callback);
    };
    Api.prototype.getDocumentTypes = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getDocumentTypesOperationSpec, callback);
    };
    Api.prototype.createDocument = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createDocumentOperationSpec, callback);
    };
    Api.prototype.getDocumentImage = function (xTenantContext, documentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            documentId: documentId,
            options: options
        }, getDocumentImageOperationSpec, callback);
    };
    Api.prototype.getDocument = function (xTenantContext, documentId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            documentId: documentId,
            options: options
        }, getDocumentOperationSpec, callback);
    };
    Api.prototype.getDocumentsInfos = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getDocumentsInfosOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentApprovals = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerDocumentApprovalsOperationSpec, callback);
    };
    Api.prototype.createCustomerDocumentApproval = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerDocumentApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentApproval = function (xTenantContext, customerId, documentApprovalId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            documentApprovalId: documentApprovalId,
            options: options
        }, getCustomerDocumentApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerDownlineCustomers = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerDownlineCustomersOperationSpec, callback);
    };
    Api.prototype.getCustomerDownlinePerformance = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerDownlinePerformanceOperationSpec, callback);
    };
    Api.prototype.getCustomerDownlineSummary = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerDownlineSummaryOperationSpec, callback);
    };
    Api.prototype.getEditorialArticles = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getEditorialArticlesOperationSpec, callback);
    };
    Api.prototype.getApplicationsEInvoiceLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsEInvoiceLocalizationOperationSpec, callback);
    };
    Api.prototype.getCustomerEInvoiceApproval = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerEInvoiceApprovalOperationSpec, callback);
    };
    Api.prototype.updateCustomerEInvoiceApproval = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerEInvoiceApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerEmails = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerEmailsOperationSpec, callback);
    };
    Api.prototype.createCustomerEmail = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerEmailOperationSpec, callback);
    };
    Api.prototype.deleteCustomerEmail = function (xTenantContext, customerId, emailAddress, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            emailAddress: emailAddress,
            options: options
        }, deleteCustomerEmailOperationSpec, callback);
    };
    Api.prototype.getCustomerEmailsMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerEmailsMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerEmailVerificationRequest = function (xTenantContext, customerId, emailAddress, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            emailAddress: emailAddress,
            options: options
        }, getCustomerEmailVerificationRequestOperationSpec, callback);
    };
    Api.prototype.updateCustomerEmailVerificationRequest = function (xTenantContext, customerId, emailAddress, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            emailAddress: emailAddress,
            options: options
        }, updateCustomerEmailVerificationRequestOperationSpec, callback);
    };
    Api.prototype.getEndConsumerOrderItem = function (xTenantContext, endConsumerOrderId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            endConsumerOrderId: endConsumerOrderId,
            itemCode: itemCode,
            options: options
        }, getEndConsumerOrderItemOperationSpec, callback);
    };
    Api.prototype.updateEndConsumerOrderItem = function (xTenantContext, endConsumerOrderId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            endConsumerOrderId: endConsumerOrderId,
            itemCode: itemCode,
            options: options
        }, updateEndConsumerOrderItemOperationSpec, callback);
    };
    Api.prototype.deleteEndConsumerOrderItem = function (xTenantContext, endConsumerOrderId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            endConsumerOrderId: endConsumerOrderId,
            itemCode: itemCode,
            options: options
        }, deleteEndConsumerOrderItemOperationSpec, callback);
    };
    Api.prototype.createEndConsumerOrderItem = function (xTenantContext, endConsumerOrderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            endConsumerOrderId: endConsumerOrderId,
            options: options
        }, createEndConsumerOrderItemOperationSpec, callback);
    };
    Api.prototype.createEndConsumerOrder = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createEndConsumerOrderOperationSpec, callback);
    };
    Api.prototype.getEndConsumerOrders = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getEndConsumerOrdersOperationSpec, callback);
    };
    Api.prototype.getEndConsumerOrder = function (xTenantContext, endConsumerOrderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            endConsumerOrderId: endConsumerOrderId,
            options: options
        }, getEndConsumerOrderOperationSpec, callback);
    };
    Api.prototype.createEndConsumerOrderApproval = function (xTenantContext, endConsumerOrderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            endConsumerOrderId: endConsumerOrderId,
            options: options
        }, createEndConsumerOrderApprovalOperationSpec, callback);
    };
    Api.prototype.deleteEndConsumerOrderApproval = function (xTenantContext, endConsumerOrderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            endConsumerOrderId: endConsumerOrderId,
            options: options
        }, deleteEndConsumerOrderApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerEndConsumers = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerEndConsumersOperationSpec, callback);
    };
    Api.prototype.createCustomerEndConsumer = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerEndConsumerOperationSpec, callback);
    };
    Api.prototype.getCustomerEndConsumer = function (xTenantContext, customerId, endConsumerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            endConsumerId: endConsumerId,
            options: options
        }, getCustomerEndConsumerOperationSpec, callback);
    };
    Api.prototype.updateCustomerEndConsumer = function (xTenantContext, customerId, endConsumerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            endConsumerId: endConsumerId,
            options: options
        }, updateCustomerEndConsumerOperationSpec, callback);
    };
    Api.prototype.deleteCustomerEndConsumer = function (xTenantContext, customerId, endConsumerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            endConsumerId: endConsumerId,
            options: options
        }, deleteCustomerEndConsumerOperationSpec, callback);
    };
    Api.prototype.getEndConsumersMetadata = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getEndConsumersMetadataOperationSpec, callback);
    };
    Api.prototype.getApplicationsEndCustomerReferralDiscountLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsEndCustomerReferralDiscountLocalizationOperationSpec, callback);
    };
    Api.prototype.createEndCustomer = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createEndCustomerOperationSpec, callback);
    };
    Api.prototype.getEndCustomersMetadata = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getEndCustomersMetadataOperationSpec, callback);
    };
    Api.prototype.getSystemEndpointsIdentityServerDeprecated = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getSystemEndpointsIdentityServerDeprecatedOperationSpec, callback);
    };
    Api.prototype.getSystemEndpointsOnlineDeprecated = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getSystemEndpointsOnlineDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerEWalletAccounts = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerEWalletAccountsOperationSpec, callback);
    };
    Api.prototype.createCustomerEWalletAccount = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerEWalletAccountOperationSpec, callback);
    };
    Api.prototype.updateCustomerEWalletAccount = function (xTenantContext, customerId, eWalletAccountId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            eWalletAccountId: eWalletAccountId,
            options: options
        }, updateCustomerEWalletAccountOperationSpec, callback);
    };
    Api.prototype.deleteCustomerEWalletAccount = function (xTenantContext, customerId, eWalletAccountId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            eWalletAccountId: eWalletAccountId,
            options: options
        }, deleteCustomerEWalletAccountOperationSpec, callback);
    };
    Api.prototype.getCustomerEWalletAccountsMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerEWalletAccountsMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerExternalAccountsWeChatUnionId = function (customerId, xTenantContext, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            xTenantContext: xTenantContext,
            options: options
        }, getCustomerExternalAccountsWeChatUnionIdOperationSpec, callback);
    };
    Api.prototype.getCustomerExternalProfiles = function (customerId, xTenantContext, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            xTenantContext: xTenantContext,
            options: options
        }, getCustomerExternalProfilesOperationSpec, callback);
    };
    Api.prototype.deleteCustomerExternalAccount = function (customerId, xTenantContext, externalProvider, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            xTenantContext: xTenantContext,
            externalProvider: externalProvider,
            options: options
        }, deleteCustomerExternalAccountOperationSpec, callback);
    };
    Api.prototype.getFeatureToggle = function (xTenantContext, featureId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            featureId: featureId,
            options: options
        }, getFeatureToggleOperationSpec, callback);
    };
    Api.prototype.getFeatureToggles = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getFeatureTogglesOperationSpec, callback);
    };
    Api.prototype.getCustomerFinancialSet = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerFinancialSetOperationSpec, callback);
    };
    Api.prototype.getProductsFormattedPrices = function (xTenantContext, productCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCodes: productCodes,
            options: options
        }, getProductsFormattedPricesOperationSpec, callback);
    };
    Api.prototype.getConceptsFormattedPrices = function (xTenantContext, conceptCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            conceptCodes: conceptCodes,
            options: options
        }, getConceptsFormattedPricesOperationSpec, callback);
    };
    Api.prototype.getApplicationsOriflameAppFrontPageBanners = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsOriflameAppFrontPageBannersOperationSpec, callback);
    };
    Api.prototype.getApplicationsOriflameAppFrontPageBanner = function (xTenantContext, frontPageBannerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            frontPageBannerId: frontPageBannerId,
            options: options
        }, getApplicationsOriflameAppFrontPageBannerOperationSpec, callback);
    };
    Api.prototype.getApplicationsFrontpageCustomerBenefitBanner = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getApplicationsFrontpageCustomerBenefitBannerOperationSpec, callback);
    };
    Api.prototype.getApplicationsGenesysWidget = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsGenesysWidgetOperationSpec, callback);
    };
    Api.prototype.getCustomerGrantedCredit = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerGrantedCreditOperationSpec, callback);
    };
    Api.prototype.updateCustomerGrantedCredit = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerGrantedCreditOperationSpec, callback);
    };
    Api.prototype.getCustomerGuaranteeCredit = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerGuaranteeCreditOperationSpec, callback);
    };
    Api.prototype.getApplicationsGuaranteeCreditLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsGuaranteeCreditLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsGuaranteeCreditGrantedCreditConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsGuaranteeCreditGrantedCreditConfigurationOperationSpec, callback);
    };
    Api.prototype.getApplicationsGuaranteeCreditCustomers = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsGuaranteeCreditCustomersOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionHomeDeliveryOptions = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionHomeDeliveryOptionsOperationSpec, callback);
    };
    Api.prototype.getCustomerIdentityCard = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerIdentityCardOperationSpec, callback);
    };
    Api.prototype.updateCustomerIdentityCard = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerIdentityCardOperationSpec, callback);
    };
    Api.prototype.getSocialMediaLibraryImageInfo = function (xTenantContext, imageInfoId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            imageInfoId: imageInfoId,
            options: options
        }, getSocialMediaLibraryImageInfoOperationSpec, callback);
    };
    Api.prototype.getSocialMediaLibraryImageInfos = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getSocialMediaLibraryImageInfosOperationSpec, callback);
    };
    Api.prototype.getInAppNotifications = function (xTenantContext, xClientApplication, acceptLanguage, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            acceptLanguage: acceptLanguage,
            options: options
        }, getInAppNotificationsOperationSpec, callback);
    };
    Api.prototype.getInAppNotificationUpdates = function (xTenantContext, xClientApplication, acceptLanguage, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            acceptLanguage: acceptLanguage,
            options: options
        }, getInAppNotificationUpdatesOperationSpec, callback);
    };
    Api.prototype.getCustomerInAppNotifications = function (xTenantContext, xClientApplication, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            options: options
        }, getCustomerInAppNotificationsOperationSpec, callback);
    };
    Api.prototype.deleteCustomerInAppNotifications = function (xTenantContext, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, deleteCustomerInAppNotificationsOperationSpec, callback);
    };
    Api.prototype.getCustomerInAppNotificationUpdates = function (xTenantContext, xClientApplication, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            options: options
        }, getCustomerInAppNotificationUpdatesOperationSpec, callback);
    };
    Api.prototype.createCustomerInAppNotificationViewed = function (xTenantContext, notificationId, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            notificationId: notificationId,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, createCustomerInAppNotificationViewedOperationSpec, callback);
    };
    Api.prototype.createCustomerInAppNotificationsViewed = function (xTenantContext, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, createCustomerInAppNotificationsViewedOperationSpec, callback);
    };
    Api.prototype.deleteCustomerInAppNotification = function (xTenantContext, notificationId, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            notificationId: notificationId,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, deleteCustomerInAppNotificationOperationSpec, callback);
    };
    Api.prototype.createCustomerInAppNotificationUndelete = function (xTenantContext, notificationId, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            notificationId: notificationId,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, createCustomerInAppNotificationUndeleteOperationSpec, callback);
    };
    Api.prototype.getNotificationMessageTypes = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getNotificationMessageTypesOperationSpec, callback);
    };
    Api.prototype.createCustomerInAppNotificationsSeen = function (xTenantContext, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, createCustomerInAppNotificationsSeenOperationSpec, callback);
    };
    Api.prototype.createCustomerInAppNotificationSeen = function (xTenantContext, notificationId, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            notificationId: notificationId,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, createCustomerInAppNotificationSeenOperationSpec, callback);
    };
    Api.prototype.getCustomerUnseenNotificationsCount = function (xTenantContext, xClientApplication, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            options: options
        }, getCustomerUnseenNotificationsCountOperationSpec, callback);
    };
    Api.prototype.getIngredients = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getIngredientsOperationSpec, callback);
    };
    Api.prototype.getIngredient = function (xTenantContext, ingredientName, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            ingredientName: ingredientName,
            options: options
        }, getIngredientOperationSpec, callback);
    };
    Api.prototype.getCustomerInternationalInfo = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerInternationalInfoOperationSpec, callback);
    };
    Api.prototype.getJoiningFeeDialogHtmlDeprecated = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getJoiningFeeDialogHtmlDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationLegalDetails = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, getCustomerRegistrationLegalDetailsOperationSpec, callback);
    };
    Api.prototype.updateCustomerRegistrationLegalDetails = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, updateCustomerRegistrationLegalDetailsOperationSpec, callback);
    };
    Api.prototype.getCustomerLegalDocument = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerLegalDocumentOperationSpec, callback);
    };
    Api.prototype.getApplicationsSocialMediaLibraryLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsSocialMediaLibraryLocalizationOperationSpec, callback);
    };
    Api.prototype.getLoginStatus = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getLoginStatusOperationSpec, callback);
    };
    Api.prototype.getAddressNodeDeprecated = function (xTenantContext, nodeId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            nodeId: nodeId,
            options: options
        }, getAddressNodeDeprecatedOperationSpec, callback);
    };
    Api.prototype.getAddressSearchResult = function (xTenantContext, addressSearchResultId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            addressSearchResultId: addressSearchResultId,
            options: options
        }, getAddressSearchResultOperationSpec, callback);
    };
    Api.prototype.getAddressSuggestions = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getAddressSuggestionsOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardLooks = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsMakeupwizardLooksOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardLooktags = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsMakeupwizardLooktagsOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsMakeupwizardLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardCategories = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsMakeupwizardCategoriesOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardWelcomeScreenSteps = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsMakeupwizardWelcomeScreenStepsOperationSpec, callback);
    };
    Api.prototype.getCustomerMaritalStatus = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerMaritalStatusOperationSpec, callback);
    };
    Api.prototype.updateCustomerMaritalStatus = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerMaritalStatusOperationSpec, callback);
    };
    Api.prototype.getCommissionPlansMatureMarketTitleQualifications = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getCommissionPlansMatureMarketTitleQualificationsOperationSpec, callback);
    };
    Api.prototype.getCustomerMenu = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerMenuOperationSpec, callback);
    };
    Api.prototype.getMobileAppsLinks = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getMobileAppsLinksOperationSpec, callback);
    };
    Api.prototype.getApplicationsOriflameappMyPage = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsOriflameappMyPageOperationSpec, callback);
    };
    Api.prototype.getCustomerNameBankContacts = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerNameBankContactsOperationSpec, callback);
    };
    Api.prototype.createCustomerNameBankContact = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerNameBankContactOperationSpec, callback);
    };
    Api.prototype.getCustomerNameBankContact = function (xTenantContext, customerId, contactId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            contactId: contactId,
            options: options
        }, getCustomerNameBankContactOperationSpec, callback);
    };
    Api.prototype.updateCustomerNameBankContact = function (xTenantContext, customerId, contactId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            contactId: contactId,
            options: options
        }, updateCustomerNameBankContactOperationSpec, callback);
    };
    Api.prototype.deleteCustomerNameBankContact = function (xTenantContext, customerId, contactId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            contactId: contactId,
            options: options
        }, deleteCustomerNameBankContactOperationSpec, callback);
    };
    Api.prototype.getApplicationsNavigationNavigation = function (xTenantContext, navigationType, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            navigationType: navigationType,
            options: options
        }, getApplicationsNavigationNavigationOperationSpec, callback);
    };
    Api.prototype.createApplicationsNavigationSignal = function (xTenantContext, acceptLanguage, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            acceptLanguage: acceptLanguage,
            options: options
        }, createApplicationsNavigationSignalOperationSpec, callback);
    };
    Api.prototype.createApplicationsNavigationSignalsBulk = function (xTenantContext, acceptLanguage, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            acceptLanguage: acceptLanguage,
            options: options
        }, createApplicationsNavigationSignalsBulkOperationSpec, callback);
    };
    Api.prototype.getApplicationsNavigationCustomerNavigation = function (xTenantContext, customerId, navigationType, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            navigationType: navigationType,
            options: options
        }, getApplicationsNavigationCustomerNavigationOperationSpec, callback);
    };
    Api.prototype.getApplicationsNavigationCustomerInfo = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getApplicationsNavigationCustomerInfoOperationSpec, callback);
    };
    Api.prototype.createCustomerNewsTop = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerNewsTopOperationSpec, callback);
    };
    Api.prototype.createNewsletterSubscription = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createNewsletterSubscriptionOperationSpec, callback);
    };
    Api.prototype.getCustomerNominee = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerNomineeOperationSpec, callback);
    };
    Api.prototype.updateCustomerNominee = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerNomineeOperationSpec, callback);
    };
    Api.prototype.createRelayNotificationsMobile = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createRelayNotificationsMobileOperationSpec, callback);
    };
    Api.prototype.createCustomerNotification = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerNotificationOperationSpec, callback);
    };
    Api.prototype.deleteCustomerNotification = function (xTenantContext, customerId, notificationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            notificationId: notificationId,
            options: options
        }, deleteCustomerNotificationOperationSpec, callback);
    };
    Api.prototype.getCustomerNotification = function (xTenantContext, customerId, notificationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            notificationId: notificationId,
            options: options
        }, getCustomerNotificationOperationSpec, callback);
    };
    Api.prototype.createCustomerNotificationSend = function (xTenantContext, customerId, notificationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            notificationId: notificationId,
            options: options
        }, createCustomerNotificationSendOperationSpec, callback);
    };
    Api.prototype.createCustomerNotificationRecall = function (xTenantContext, customerId, notificationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            notificationId: notificationId,
            options: options
        }, createCustomerNotificationRecallOperationSpec, callback);
    };
    Api.prototype.createCustomerNotificationsSearch = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerNotificationsSearchOperationSpec, callback);
    };
    Api.prototype.getCustomersNotificationsTargets = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getCustomersNotificationsTargetsOperationSpec, callback);
    };
    Api.prototype.getNotificationCategories = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getNotificationCategoriesOperationSpec, callback);
    };
    Api.prototype.getCustomerCustomerAttributeDeprecated = function (xTenantContext, customerId, customerAttributeTypeId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            customerAttributeTypeId: customerAttributeTypeId,
            options: options
        }, getCustomerCustomerAttributeDeprecatedOperationSpec, callback);
    };
    Api.prototype.updateCustomerCustomerAttributeDeprecated = function (xTenantContext, customerId, customerAttributeTypeId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            customerAttributeTypeId: customerAttributeTypeId,
            options: options
        }, updateCustomerCustomerAttributeDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerCustomerAttributesDeprecated = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerCustomerAttributesDeprecatedOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionOfferChoices = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionOfferChoicesOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionOfferChoices = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, updateShoppingSessionOfferChoicesOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionOfferChoices = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, deleteShoppingSessionOfferChoicesOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionOfferChoice = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, createShoppingSessionOfferChoiceOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionOfferChoice = function (xTenantContext, sessionId, offerId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            itemCode: itemCode,
            options: options
        }, getShoppingSessionOfferChoiceOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionOfferChoice = function (xTenantContext, sessionId, offerId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            itemCode: itemCode,
            options: options
        }, updateShoppingSessionOfferChoiceOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionOfferChoice = function (xTenantContext, sessionId, offerId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            itemCode: itemCode,
            options: options
        }, deleteShoppingSessionOfferChoiceOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionOfferOfferItems = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionOfferOfferItemsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionOffers = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionOffersOperationSpec, callback);
    };
    Api.prototype.getCustomerOnboarding = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerOnboardingOperationSpec, callback);
    };
    Api.prototype.updateCustomerOnboarding = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerOnboardingOperationSpec, callback);
    };
    Api.prototype.getCustomerOnboardingMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerOnboardingMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerOnboardingTest = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerOnboardingTestOperationSpec, callback);
    };
    Api.prototype.updateCustomerOnboardingTest = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerOnboardingTestOperationSpec, callback);
    };
    Api.prototype.getTestsSmallSizeResponseOnline = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getTestsSmallSizeResponseOnlineOperationSpec, callback);
    };
    Api.prototype.getTestsMediumSizeResponseOnline = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getTestsMediumSizeResponseOnlineOperationSpec, callback);
    };
    Api.prototype.getTestsBigSizeResponseOnline = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getTestsBigSizeResponseOnlineOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionOrder = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, createShoppingSessionOrderOperationSpec, callback);
    };
    Api.prototype.getApplicationsOrderHistoryCustomerKpi = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getApplicationsOrderHistoryCustomerKpiOperationSpec, callback);
    };
    Api.prototype.getApplicationsOrderHistoryCustomerConfiguration = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getApplicationsOrderHistoryCustomerConfigurationOperationSpec, callback);
    };
    Api.prototype.getOrderItems = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getOrderItemsOperationSpec, callback);
    };
    Api.prototype.getOrders = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getOrdersOperationSpec, callback);
    };
    Api.prototype.createOrder = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createOrderOperationSpec, callback);
    };
    Api.prototype.getOrder = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderOperationSpec, callback);
    };
    Api.prototype.deleteOrder = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, deleteOrderOperationSpec, callback);
    };
    Api.prototype.getOrderOperationPrincipals = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderOperationPrincipalsOperationSpec, callback);
    };
    Api.prototype.getCustomerOrdersLastUnpaid = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerOrdersLastUnpaidOperationSpec, callback);
    };
    Api.prototype.getOrderRealtimeOrderTracking = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderRealtimeOrderTrackingOperationSpec, callback);
    };
    Api.prototype.getOrderPaymentProvider = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderPaymentProviderOperationSpec, callback);
    };
    Api.prototype.updateOrderPaymentProvider = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, updateOrderPaymentProviderOperationSpec, callback);
    };
    Api.prototype.getOrderDiscounts = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderDiscountsOperationSpec, callback);
    };
    Api.prototype.getOrderEndConsumers = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderEndConsumersOperationSpec, callback);
    };
    Api.prototype.getOrderStatuses = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getOrderStatusesOperationSpec, callback);
    };
    Api.prototype.getOrderNavigation = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderNavigationOperationSpec, callback);
    };
    Api.prototype.getApplicationsOrderSummaryOrderSummary = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getApplicationsOrderSummaryOrderSummaryOperationSpec, callback);
    };
    Api.prototype.getCustomerOriflameCard = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerOriflameCardOperationSpec, callback);
    };
    Api.prototype.getApplicationsOutdatedBrowserInfoLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsOutdatedBrowserInfoLocalizationOperationSpec, callback);
    };
    Api.prototype.getOrderPaymentMethods = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderPaymentMethodsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPaymentMethods = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionPaymentMethodsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPaymentProviders = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionPaymentProvidersOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPaymentProvider = function (xTenantContext, sessionId, paymentProviderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            paymentProviderId: paymentProviderId,
            options: options
        }, getShoppingSessionPaymentProviderOperationSpec, callback);
    };
    Api.prototype.getPaymentProvider = function (xTenantContext, paymentProviderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            paymentProviderId: paymentProviderId,
            options: options
        }, getPaymentProviderOperationSpec, callback);
    };
    Api.prototype.getOrderPaymentProviders = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderPaymentProvidersOperationSpec, callback);
    };
    Api.prototype.createCustomerOrderPaymentDatum = function (xTenantContext, customerId, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            orderId: orderId,
            options: options
        }, createCustomerOrderPaymentDatumOperationSpec, callback);
    };
    Api.prototype.createCustomerOrderSharedPaymentDatum = function (xTenantContext, customerId, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            orderId: orderId,
            options: options
        }, createCustomerOrderSharedPaymentDatumOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPayment = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionPaymentOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionPayment = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, updateShoppingSessionPaymentOperationSpec, callback);
    };
    Api.prototype.getOrderPendingPaymentsResult = function (xTenantContext, orderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            orderId: orderId,
            options: options
        }, getOrderPendingPaymentsResultOperationSpec, callback);
    };
    Api.prototype.getPendingRegistration = function (xTenantContext, pendingRegistrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            pendingRegistrationId: pendingRegistrationId,
            options: options
        }, getPendingRegistrationOperationSpec, callback);
    };
    Api.prototype.updatePendingRegistration = function (xTenantContext, pendingRegistrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            pendingRegistrationId: pendingRegistrationId,
            options: options
        }, updatePendingRegistrationOperationSpec, callback);
    };
    Api.prototype.createPendingRegistration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createPendingRegistrationOperationSpec, callback);
    };
    Api.prototype.getPendingRegistrationsMetadata = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPendingRegistrationsMetadataOperationSpec, callback);
    };
    Api.prototype.getPeriod = function (xTenantContext, periodCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            periodCode: periodCode,
            options: options
        }, getPeriodOperationSpec, callback);
    };
    Api.prototype.getPeriods = function (xTenantContext, offsets, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            offsets: offsets,
            options: options
        }, getPeriodsOperationSpec, callback);
    };
    Api.prototype.getPeriodsCurrentPeriod = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPeriodsCurrentPeriodOperationSpec, callback);
    };
    Api.prototype.getPeriodTasks = function (xTenantContext, periodCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            periodCode: periodCode,
            options: options
        }, getPeriodTasksOperationSpec, callback);
    };
    Api.prototype.getPeriodTask = function (xTenantContext, periodCode, taskId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            periodCode: periodCode,
            taskId: taskId,
            options: options
        }, getPeriodTaskOperationSpec, callback);
    };
    Api.prototype.getConceptsPermissions = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getConceptsPermissionsOperationSpec, callback);
    };
    Api.prototype.getConceptPermission = function (xTenantContext, conceptCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            conceptCode: conceptCode,
            options: options
        }, getConceptPermissionOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptsPermissions = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerConceptsPermissionsOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptPermission = function (xTenantContext, customerId, conceptCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            conceptCode: conceptCode,
            options: options
        }, getCustomerConceptPermissionOperationSpec, callback);
    };
    Api.prototype.getProductsPermissions = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getProductsPermissionsOperationSpec, callback);
    };
    Api.prototype.getProductPermission = function (xTenantContext, productCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCode: productCode,
            options: options
        }, getProductPermissionOperationSpec, callback);
    };
    Api.prototype.getCustomerProductPermission = function (xTenantContext, customerId, productCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productCode: productCode,
            options: options
        }, getCustomerProductPermissionOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsPermissions = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProductsPermissionsOperationSpec, callback);
    };
    Api.prototype.getCustomerRolesPermissions = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerRolesPermissionsOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalBeautyStore = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPersonalBeautyStoreOperationSpec, callback);
    };
    Api.prototype.createCustomerPersonalBeautyStore = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerPersonalBeautyStoreOperationSpec, callback);
    };
    Api.prototype.updateCustomerPersonalBeautyStore = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerPersonalBeautyStoreOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalBeautyStoreMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPersonalBeautyStoreMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalBeautyStoreProfile = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPersonalBeautyStoreProfileOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalBeautyStoreDynamiclink = function (xTenantContext, xClientApplication, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            options: options
        }, getCustomerPersonalBeautyStoreDynamiclinkOperationSpec, callback);
    };
    Api.prototype.getPersonalBeautyStoreConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPersonalBeautyStoreConfigurationOperationSpec, callback);
    };
    Api.prototype.getPersonalBeautyStore = function (xTenantContext, name, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            name: name,
            options: options
        }, getPersonalBeautyStoreOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationPersonalDetails = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, getCustomerRegistrationPersonalDetailsOperationSpec, callback);
    };
    Api.prototype.updateCustomerRegistrationPersonalDetails = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, updateCustomerRegistrationPersonalDetailsOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalDocument = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPersonalDocumentOperationSpec, callback);
    };
    Api.prototype.updateCustomerPersonalDocument = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerPersonalDocumentOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalMenuLocalizationDeprecated = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsPersonalMenuLocalizationDeprecatedOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalMenu = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsPersonalMenuOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalMenuOrisalesMenu = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsPersonalMenuOrisalesMenuOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalPerformance = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPersonalPerformanceOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalProductsListLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsPersonalProductsListLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalProductsListConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsPersonalProductsListConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerPhones = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPhonesOperationSpec, callback);
    };
    Api.prototype.createCustomerPhone = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerPhoneOperationSpec, callback);
    };
    Api.prototype.updateCustomerPhone = function (xTenantContext, customerId, telephoneId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            telephoneId: telephoneId,
            options: options
        }, updateCustomerPhoneOperationSpec, callback);
    };
    Api.prototype.deleteCustomerPhone = function (xTenantContext, customerId, telephoneId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            telephoneId: telephoneId,
            options: options
        }, deleteCustomerPhoneOperationSpec, callback);
    };
    Api.prototype.getCustomerPhonesMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPhonesMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerPhoneVerificationRequest = function (xTenantContext, customerId, telephoneId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            telephoneId: telephoneId,
            options: options
        }, getCustomerPhoneVerificationRequestOperationSpec, callback);
    };
    Api.prototype.updateCustomerPhoneVerificationRequest = function (xTenantContext, customerId, telephoneId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            telephoneId: telephoneId,
            options: options
        }, updateCustomerPhoneVerificationRequestOperationSpec, callback);
    };
    Api.prototype.getPopularProducts = function (xTenantContext, type, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            type: type,
            options: options
        }, getPopularProductsOperationSpec, callback);
    };
    Api.prototype.getCustomerPreferences = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPreferencesOperationSpec, callback);
    };
    Api.prototype.updateCustomerPreferences = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerPreferencesOperationSpec, callback);
    };
    Api.prototype.getCustomerPreferencesMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerPreferencesMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerCheckoutPrerequisites = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerCheckoutPrerequisitesOperationSpec, callback);
    };
    Api.prototype.getConceptsPrices = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getConceptsPricesOperationSpec, callback);
    };
    Api.prototype.getConceptPrice = function (xTenantContext, conceptCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            conceptCode: conceptCode,
            options: options
        }, getConceptPriceOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptsPrices = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerConceptsPricesOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptPrice = function (xTenantContext, customerId, conceptCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            conceptCode: conceptCode,
            options: options
        }, getCustomerConceptPriceOperationSpec, callback);
    };
    Api.prototype.getProductsPrices = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getProductsPricesOperationSpec, callback);
    };
    Api.prototype.getCustomerProductPrice = function (xTenantContext, customerId, productCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productCode: productCode,
            options: options
        }, getCustomerProductPriceOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsPrices = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProductsPricesOperationSpec, callback);
    };
    Api.prototype.getProductBundle = function (xTenantContext, productCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCode: productCode,
            options: options
        }, getProductBundleOperationSpec, callback);
    };
    Api.prototype.getProductBundles = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getProductBundlesOperationSpec, callback);
    };
    Api.prototype.getProductLabelsContent = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getProductLabelsContentOperationSpec, callback);
    };
    Api.prototype.getProductListTypeProductList = function (xTenantContext, productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productListType: productListType,
            productListId: productListId,
            options: options
        }, getProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.getCustomerProductListTypeProductLists = function (xTenantContext, customerId, productListType, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productListType: productListType,
            options: options
        }, getCustomerProductListTypeProductListsOperationSpec, callback);
    };
    Api.prototype.createCustomerProductListTypeProductList = function (xTenantContext, customerId, productListType, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productListType: productListType,
            options: options
        }, createCustomerProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.getCustomerProductListTypeProductList = function (xTenantContext, customerId, productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productListType: productListType,
            productListId: productListId,
            options: options
        }, getCustomerProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.updateCustomerProductListTypeProductList = function (xTenantContext, customerId, productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productListType: productListType,
            productListId: productListId,
            options: options
        }, updateCustomerProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.deleteCustomerProductListTypeProductList = function (xTenantContext, customerId, productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productListType: productListType,
            productListId: productListId,
            options: options
        }, deleteCustomerProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.deleteCustomerProductListTypeProductListItem = function (xTenantContext, customerId, productListType, productListId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productListType: productListType,
            productListId: productListId,
            itemCode: itemCode,
            options: options
        }, deleteCustomerProductListTypeProductListItemOperationSpec, callback);
    };
    Api.prototype.createCustomerProductListTypeProductListItem = function (xTenantContext, customerId, productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productListType: productListType,
            productListId: productListId,
            options: options
        }, createCustomerProductListTypeProductListItemOperationSpec, callback);
    };
    Api.prototype.getCustomerProductListTypeProductListDynamiclink = function (xTenantContext, xClientApplication, customerId, productListId, productListType, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            productListId: productListId,
            productListType: productListType,
            options: options
        }, getCustomerProductListTypeProductListDynamiclinkOperationSpec, callback);
    };
    Api.prototype.getApplicationsProductListingListings = function (xTenantContext, productListingPageId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productListingPageId: productListingPageId,
            options: options
        }, getApplicationsProductListingListingsOperationSpec, callback);
    };
    Api.prototype.getApplicationsProductListingPromoBanners = function (xTenantContext, ids, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            ids: ids,
            options: options
        }, getApplicationsProductListingPromoBannersOperationSpec, callback);
    };
    Api.prototype.getProducts = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getProductsOperationSpec, callback);
    };
    Api.prototype.getProduct = function (xTenantContext, productCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCode: productCode,
            options: options
        }, getProductOperationSpec, callback);
    };
    Api.prototype.getProductsExpectedInbounds = function (xTenantContext, productCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCodes: productCodes,
            options: options
        }, getProductsExpectedInboundsOperationSpec, callback);
    };
    Api.prototype.getProductsIngredients = function (xTenantContext, productCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCodes: productCodes,
            options: options
        }, getProductsIngredientsOperationSpec, callback);
    };
    Api.prototype.getProductsLabels = function (xTenantContext, productCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCodes: productCodes,
            options: options
        }, getProductsLabelsOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsReplacements = function (xTenantContext, customerId, productCodes, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            productCodes: productCodes,
            options: options
        }, getCustomerProductsReplacementsOperationSpec, callback);
    };
    Api.prototype.getApplicationsShoppingBagProducts = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsShoppingBagProductsOperationSpec, callback);
    };
    Api.prototype.getCustomerProfile = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProfileOperationSpec, callback);
    };
    Api.prototype.updateCustomerProfile = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerProfileOperationSpec, callback);
    };
    Api.prototype.getCustomerProfileMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProfileMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerProfileCompleteness = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProfileCompletenessOperationSpec, callback);
    };
    Api.prototype.getCustomerProfileCompletenessMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProfileCompletenessMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerApplicationsProfileConfigurationsSections = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerApplicationsProfileConfigurationsSectionsOperationSpec, callback);
    };
    Api.prototype.getCustomerProfileApproval = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProfileApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerProfileImage = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProfileImageOperationSpec, callback);
    };
    Api.prototype.updateCustomerProfileImage = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerProfileImageOperationSpec, callback);
    };
    Api.prototype.getCustomerProfileImageMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerProfileImageMetadataOperationSpec, callback);
    };
    Api.prototype.getPromotion = function (xTenantContext, promotionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            promotionId: promotionId,
            options: options
        }, getPromotionOperationSpec, callback);
    };
    Api.prototype.getPromotionBestOffersBanners = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPromotionBestOffersBannersOperationSpec, callback);
    };
    Api.prototype.getPromotionWhatsNewBanners = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPromotionWhatsNewBannersOperationSpec, callback);
    };
    Api.prototype.getPromotionHeroBanners = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPromotionHeroBannersOperationSpec, callback);
    };
    Api.prototype.getPromotionCampaignBanners = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPromotionCampaignBannersOperationSpec, callback);
    };
    Api.prototype.getPromotionCategoryBanners = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPromotionCategoryBannersOperationSpec, callback);
    };
    Api.prototype.getDigitalPromotions = function (xTenantContext, channel, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            channel: channel,
            options: options
        }, getDigitalPromotionsOperationSpec, callback);
    };
    Api.prototype.getPromotions = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getPromotionsOperationSpec, callback);
    };
    Api.prototype.createPushNotificationsInstallation = function (xTenantContext, acceptLanguage, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            acceptLanguage: acceptLanguage,
            xClientApplication: xClientApplication,
            options: options
        }, createPushNotificationsInstallationOperationSpec, callback);
    };
    Api.prototype.createCustomerPushNotificationsInstallation = function (xTenantContext, xClientApplication, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            options: options
        }, createCustomerPushNotificationsInstallationOperationSpec, callback);
    };
    Api.prototype.deleteCustomerPushNotificationsInstallation = function (xTenantContext, xClientApplication, customerId, installationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            installationId: installationId,
            options: options
        }, deleteCustomerPushNotificationsInstallationOperationSpec, callback);
    };
    Api.prototype.createPushNotificationsRegistration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createPushNotificationsRegistrationOperationSpec, callback);
    };
    Api.prototype.deletePushNotificationsApplicationRegistrationId = function (xTenantContext, applicationKey, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            applicationKey: applicationKey,
            registrationId: registrationId,
            options: options
        }, deletePushNotificationsApplicationRegistrationIdOperationSpec, callback);
    };
    Api.prototype.deletePushNotificationsApplicationDeviceToken = function (xTenantContext, applicationKey, deviceToken, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            applicationKey: applicationKey,
            deviceToken: deviceToken,
            options: options
        }, deletePushNotificationsApplicationDeviceTokenOperationSpec, callback);
    };
    Api.prototype.getApplicationsRealTimeOrderTrackingLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsRealTimeOrderTrackingLocalizationOperationSpec, callback);
    };
    Api.prototype.getCustomerRecurringPaymentCards = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerRecurringPaymentCardsOperationSpec, callback);
    };
    Api.prototype.deleteCustomerRecurringPaymentCard = function (xTenantContext, customerId, recurringPaymentCardId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            recurringPaymentCardId: recurringPaymentCardId,
            options: options
        }, deleteCustomerRecurringPaymentCardOperationSpec, callback);
    };
    Api.prototype.getCustomerRecurringPaymentCardsMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerRecurringPaymentCardsMetadataOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionReferral = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionReferralOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionReferral = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, createShoppingSessionReferralOperationSpec, callback);
    };
    Api.prototype.createCustomerConsultant = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerConsultantOperationSpec, callback);
    };
    Api.prototype.createConsultant = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createConsultantOperationSpec, callback);
    };
    Api.prototype.getCustomerConsultantsMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerConsultantsMetadataOperationSpec, callback);
    };
    Api.prototype.getConsultantsMetadata = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getConsultantsMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationOrder = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerRegistrationOrderOperationSpec, callback);
    };
    Api.prototype.createCustomerRegistrationOrder = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerRegistrationOrderOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistration = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, getCustomerRegistrationOperationSpec, callback);
    };
    Api.prototype.updateCustomerRegistration = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, updateCustomerRegistrationOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationsCustomer = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerRegistrationsCustomerOperationSpec, callback);
    };
    Api.prototype.createCustomerRegistration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createCustomerRegistrationOperationSpec, callback);
    };
    Api.prototype.getProductRelations = function (xTenantContext, productCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            productCode: productCode,
            options: options
        }, getProductRelationsOperationSpec, callback);
    };
    Api.prototype.createReportingReportsInstall = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createReportingReportsInstallOperationSpec, callback);
    };
    Api.prototype.getRequiredTerms = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getRequiredTermsOperationSpec, callback);
    };
    Api.prototype.createRevolutProfile = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createRevolutProfileOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSales = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSalesOperationSpec, callback);
    };
    Api.prototype.getSalesmanagoClientData = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getSalesmanagoClientDataOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSectionSectionItems = function (xTenantContext, sessionId, sectionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            sectionId: sectionId,
            options: options
        }, getShoppingSessionSectionSectionItemsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSections = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSectionsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSectionSuggestions = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSectionSuggestionsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSectionWishlistItems = function (xTenantContext, sessionId, sectionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            sectionId: sectionId,
            options: options
        }, getShoppingSessionSectionWishlistItemsOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSectionWishlistItems = function (xTenantContext, sessionId, sectionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            sectionId: sectionId,
            options: options
        }, deleteShoppingSessionSectionWishlistItemsOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionSectionWishlist = function (xTenantContext, sessionId, sectionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            sectionId: sectionId,
            options: options
        }, createShoppingSessionSectionWishlistOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSectionWishlist = function (xTenantContext, sessionId, sectionId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            sectionId: sectionId,
            itemCode: itemCode,
            options: options
        }, getShoppingSessionSectionWishlistOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionSectionWishlist = function (xTenantContext, sessionId, sectionId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            sectionId: sectionId,
            itemCode: itemCode,
            options: options
        }, updateShoppingSessionSectionWishlistOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSectionWishlist = function (xTenantContext, sessionId, sectionId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            sectionId: sectionId,
            itemCode: itemCode,
            options: options
        }, deleteShoppingSessionSectionWishlistOperationSpec, callback);
    };
    Api.prototype.getApplicationsNetworkCommunicationConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsNetworkCommunicationConfigurationOperationSpec, callback);
    };
    Api.prototype.getApplicationsNetworkCommunicationLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsNetworkCommunicationLocalizationOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShippingJokerChoice = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionShippingJokerChoiceOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShippingJokerChoice = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionShippingJokerChoiceOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionShippingJokerChoice = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, createShoppingSessionShippingJokerChoiceOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShippingJokerChoices = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionShippingJokerChoicesOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShippingJokerChoices = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionShippingJokerChoicesOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionShippingJokerChoices = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, updateShoppingSessionShippingJokerChoicesOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShippingJokers = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionShippingJokersOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionShoppingBag = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, createShoppingSessionShoppingBagOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShoppingBag = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionShoppingBagOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShoppingBagAggregatedItems = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionShoppingBagAggregatedItemsOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionShoppingBagBagItem = function (xTenantContext, sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, updateShoppingSessionShoppingBagBagItemOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShoppingBagBagItem = function (xTenantContext, sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, deleteShoppingSessionShoppingBagBagItemOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShoppingBagBagItemBackorder = function (xTenantContext, sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, getShoppingSessionShoppingBagBagItemBackorderOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionShoppingBagBagItemBackorder = function (xTenantContext, sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, createShoppingSessionShoppingBagBagItemBackorderOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShoppingBagBagItemBackorder = function (xTenantContext, sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, deleteShoppingSessionShoppingBagBagItemBackorderOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPendingBackorders = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionPendingBackordersOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionShoppingBagBagItem = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, createShoppingSessionShoppingBagBagItemOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionShoppingBagBagItems = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, updateShoppingSessionShoppingBagBagItemsOperationSpec, callback);
    };
    Api.prototype.updateApplicationsWechatpbsShoppingSessionShoppingBagBagItems = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, updateApplicationsWechatpbsShoppingSessionShoppingBagBagItemsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionCampaignPoints = function (xTenantContext, sessionId, campaignId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            campaignId: campaignId,
            options: options
        }, getShoppingSessionCampaignPointsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionEndConsumerOrders = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionEndConsumerOrdersOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionEndConsumerOrder = function (xTenantContext, sessionId, endConsumerOrderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            endConsumerOrderId: endConsumerOrderId,
            options: options
        }, deleteShoppingSessionEndConsumerOrderOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionEndConsumerOrderItems = function (xTenantContext, sessionId, endConsumerOrderId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            endConsumerOrderId: endConsumerOrderId,
            options: options
        }, getShoppingSessionEndConsumerOrderItemsOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionEndConsumerOrderItem = function (xTenantContext, sessionId, endConsumerOrderId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            endConsumerOrderId: endConsumerOrderId,
            itemCode: itemCode,
            options: options
        }, updateShoppingSessionEndConsumerOrderItemOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionEndConsumerOrderItem = function (xTenantContext, sessionId, endConsumerOrderId, itemCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            endConsumerOrderId: endConsumerOrderId,
            itemCode: itemCode,
            options: options
        }, deleteShoppingSessionEndConsumerOrderItemOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionMessages = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionMessagesOperationSpec, callback);
    };
    Api.prototype.createShoppingSession = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createShoppingSessionOperationSpec, callback);
    };
    Api.prototype.getShoppingSession = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSession = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionOperationSpec, callback);
    };
    Api.prototype.createApplicationsSocialMediaLibraryCustomerSocialEntityVisit = function (xTenantContext, customerId, entityId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            entityId: entityId,
            options: options
        }, createApplicationsSocialMediaLibraryCustomerSocialEntityVisitOperationSpec, callback);
    };
    Api.prototype.createApplicationsSocialMediaLibraryCustomerSocialEntityLike = function (xTenantContext, customerId, entityId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            entityId: entityId,
            options: options
        }, createApplicationsSocialMediaLibraryCustomerSocialEntityLikeOperationSpec, callback);
    };
    Api.prototype.deleteApplicationsSocialMediaLibraryCustomerSocialEntityLike = function (xTenantContext, customerId, entityId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            entityId: entityId,
            options: options
        }, deleteApplicationsSocialMediaLibraryCustomerSocialEntityLikeOperationSpec, callback);
    };
    Api.prototype.getApplicationsSocialMediaLibraryCustomerSocialEntityLikes = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getApplicationsSocialMediaLibraryCustomerSocialEntityLikesOperationSpec, callback);
    };
    Api.prototype.getApplicationsSocialMediaLibraryStats = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsSocialMediaLibraryStatsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOffer = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionSpecialOfferOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOfferChoice = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionSpecialOfferChoiceOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionSpecialOfferChoice = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, updateShoppingSessionSpecialOfferChoiceOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSpecialOfferChoice = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, deleteShoppingSessionSpecialOfferChoiceOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOfferReplacements = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionSpecialOfferReplacementsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOffers = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSpecialOffersOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOfferVoucher = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionSpecialOfferVoucherOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionSpecialOfferVoucherChoice = function (xTenantContext, sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, createShoppingSessionSpecialOfferVoucherChoiceOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSpecialOfferVoucherChoice = function (xTenantContext, sessionId, choiceId, offerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            choiceId: choiceId,
            offerId: offerId,
            options: options
        }, deleteShoppingSessionSpecialOfferVoucherChoiceOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationSponsorDetails = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, getCustomerRegistrationSponsorDetailsOperationSpec, callback);
    };
    Api.prototype.updateCustomerRegistrationSponsorDetails = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, updateCustomerRegistrationSponsorDetailsOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationSponsorDetailsSponsorInfo = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, getCustomerRegistrationSponsorDetailsSponsorInfoOperationSpec, callback);
    };
    Api.prototype.getCustomerRegistrationSponsorDetailsProfileImage = function (xTenantContext, registrationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            registrationId: registrationId,
            options: options
        }, getCustomerRegistrationSponsorDetailsProfileImageOperationSpec, callback);
    };
    Api.prototype.getCustomerSponsors = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerSponsorsOperationSpec, callback);
    };
    Api.prototype.getCustomerStepsToSuccessTasks = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerStepsToSuccessTasksOperationSpec, callback);
    };
    Api.prototype.getCustomerStepsToSuccessTasksPhases = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerStepsToSuccessTasksPhasesOperationSpec, callback);
    };
    Api.prototype.getCustomerStepsToSuccessTask = function (xTenantContext, customerId, taskId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            taskId: taskId,
            options: options
        }, getCustomerStepsToSuccessTaskOperationSpec, callback);
    };
    Api.prototype.createCustomerStepsToSuccessComplete = function (xTenantContext, taskId, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            taskId: taskId,
            customerId: customerId,
            options: options
        }, createCustomerStepsToSuccessCompleteOperationSpec, callback);
    };
    Api.prototype.getCustomerSubscriptionConfiguration = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerSubscriptionConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerSubscriptionAvailabilities = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerSubscriptionAvailabilitiesOperationSpec, callback);
    };
    Api.prototype.getCustomerSubscriptionTypes = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerSubscriptionTypesOperationSpec, callback);
    };
    Api.prototype.createCustomerSubscriptionInstruction = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerSubscriptionInstructionOperationSpec, callback);
    };
    Api.prototype.getCustomerSubscriptions = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerSubscriptionsOperationSpec, callback);
    };
    Api.prototype.deleteCustomerSubscription = function (xTenantContext, customerId, subscriptionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            subscriptionId: subscriptionId,
            options: options
        }, deleteCustomerSubscriptionOperationSpec, callback);
    };
    Api.prototype.updateCustomerSubscription = function (xTenantContext, customerId, subscriptionId, body, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            subscriptionId: subscriptionId,
            body: body,
            options: options
        }, updateCustomerSubscriptionOperationSpec, callback);
    };
    Api.prototype.updateCustomerSubscriptionSubscriptionItem = function (xTenantContext, customerId, subscriptionId, subscriptionItemId, body, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            subscriptionId: subscriptionId,
            subscriptionItemId: subscriptionItemId,
            body: body,
            options: options
        }, updateCustomerSubscriptionSubscriptionItemOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSubscriptions = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSubscriptionsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSubscription = function (xTenantContext, sessionId, subscriptionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            subscriptionId: subscriptionId,
            options: options
        }, getShoppingSessionSubscriptionOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSubscription = function (xTenantContext, sessionId, subscriptionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            subscriptionId: subscriptionId,
            options: options
        }, deleteShoppingSessionSubscriptionOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSubscriptionSteps = function (xTenantContext, sessionId, subscriptionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            subscriptionId: subscriptionId,
            options: options
        }, getShoppingSessionSubscriptionStepsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSubscriptionStep = function (xTenantContext, sessionId, subscriptionId, stepNumber, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            subscriptionId: subscriptionId,
            stepNumber: stepNumber,
            options: options
        }, getShoppingSessionSubscriptionStepOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSubscriptionStep = function (xTenantContext, sessionId, subscriptionId, stepNumber, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            subscriptionId: subscriptionId,
            stepNumber: stepNumber,
            options: options
        }, deleteShoppingSessionSubscriptionStepOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSubscriptionCycleStep = function (xTenantContext, sessionId, subscriptionId, cycleNumber, stepNumber, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            subscriptionId: subscriptionId,
            cycleNumber: cycleNumber,
            stepNumber: stepNumber,
            options: options
        }, deleteShoppingSessionSubscriptionCycleStepOperationSpec, callback);
    };
    Api.prototype.getApplicationsSubscriptionWizardLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsSubscriptionWizardLocalizationOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSummary = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSummaryOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSummaryAccounts = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSummaryAccountsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSummaryDiscounts = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSummaryDiscountsOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterCategories = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsSupportCenterCategoriesOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterCategory = function (xTenantContext, categoryId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            categoryId: categoryId,
            options: options
        }, getApplicationsSupportCenterCategoryOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterLocalizationDeprecated = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsSupportCenterLocalizationDeprecatedOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterFeaturedFaqs = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsSupportCenterFeaturedFaqsOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterSearch = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsSupportCenterSearchOperationSpec, callback);
    };
    Api.prototype.getProductsTagGroups = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getProductsTagGroupsOperationSpec, callback);
    };
    Api.prototype.getCustomerTaxDocument = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerTaxDocumentOperationSpec, callback);
    };
    Api.prototype.updateCustomerTaxDocument = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerTaxDocumentOperationSpec, callback);
    };
    Api.prototype.getCustomerTerminationStatus = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerTerminationStatusOperationSpec, callback);
    };
    Api.prototype.updateCustomerTerminationStatus = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerTerminationStatusOperationSpec, callback);
    };
    Api.prototype.getTermHtmlDeprecated = function (xTenantContext, termId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            termId: termId,
            options: options
        }, getTermHtmlDeprecatedOperationSpec, callback);
    };
    Api.prototype.getTestPing = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getTestPingOperationSpec, callback);
    };
    Api.prototype.getCustomerUpgradeRequest = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerUpgradeRequestOperationSpec, callback);
    };
    Api.prototype.updateCustomerUpgradeRequest = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerUpgradeRequestOperationSpec, callback);
    };
    Api.prototype.getCustomerUpgradeRequestMetadata = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerUpgradeRequestMetadataOperationSpec, callback);
    };
    Api.prototype.getBusinessToolCustomerSetting = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getBusinessToolCustomerSettingOperationSpec, callback);
    };
    Api.prototype.deleteBusinessToolCustomerSetting = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, deleteBusinessToolCustomerSettingOperationSpec, callback);
    };
    Api.prototype.updateBusinessToolCustomerSetting = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateBusinessToolCustomerSettingOperationSpec, callback);
    };
    Api.prototype.getSettingsClientSettingCustomer = function (xTenantContext, settingsClient, settingId, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            settingsClient: settingsClient,
            settingId: settingId,
            customerId: customerId,
            options: options
        }, getSettingsClientSettingCustomerOperationSpec, callback);
    };
    Api.prototype.updateSettingsClientSettingCustomer = function (xTenantContext, settingsClient, settingId, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            settingsClient: settingsClient,
            settingId: settingId,
            customerId: customerId,
            options: options
        }, updateSettingsClientSettingCustomerOperationSpec, callback);
    };
    Api.prototype.deleteSettingsClientSettingCustomer = function (xTenantContext, settingsClient, settingId, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            settingsClient: settingsClient,
            settingId: settingId,
            customerId: customerId,
            options: options
        }, deleteSettingsClientSettingCustomerOperationSpec, callback);
    };
    Api.prototype.getCustomerVatDocumentType = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerVatDocumentTypeOperationSpec, callback);
    };
    Api.prototype.updateCustomerVatDocumentType = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerVatDocumentTypeOperationSpec, callback);
    };
    Api.prototype.getApplicationsVideoShoppingLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsVideoShoppingLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsVideoShoppingConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsVideoShoppingConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerVideoShoppingShows = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerVideoShoppingShowsOperationSpec, callback);
    };
    Api.prototype.createCustomerVideoShoppingInvitation = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, createCustomerVideoShoppingInvitationOperationSpec, callback);
    };
    Api.prototype.getCustomerVipCustomerBanner = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerVipCustomerBannerOperationSpec, callback);
    };
    Api.prototype.getVipLoyaltyCampaignStepperConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getVipLoyaltyCampaignStepperConfigurationOperationSpec, callback);
    };
    Api.prototype.getApplicationsVipUpgradeLocalizationDeprecated = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsVipUpgradeLocalizationDeprecatedOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionVoucherCodes = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionVoucherCodesOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionVoucherCodes = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionVoucherCodesOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionVoucherCode = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, createShoppingSessionVoucherCodeOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionVoucherCode = function (xTenantContext, sessionId, voucherCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            voucherCode: voucherCode,
            options: options
        }, getShoppingSessionVoucherCodeOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionVoucherCode = function (xTenantContext, sessionId, voucherCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            voucherCode: voucherCode,
            options: options
        }, deleteShoppingSessionVoucherCodeOperationSpec, callback);
    };
    Api.prototype.getVouchers = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getVouchersOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionVouchers = function (xTenantContext, sessionId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            sessionId: sessionId,
            options: options
        }, getShoppingSessionVouchersOperationSpec, callback);
    };
    Api.prototype.getApplicationsVouchersLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsVouchersLocalizationOperationSpec, callback);
    };
    Api.prototype.createApplicationsVideoShoppingAccountUserEvent = function (accountId, options, callback) {
        return this.sendOperationRequest({
            accountId: accountId,
            options: options
        }, createApplicationsVideoShoppingAccountUserEventOperationSpec, callback);
    };
    Api.prototype.createLoginProvidersWeChatExternalAccount = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createLoginProvidersWeChatExternalAccountOperationSpec, callback);
    };
    Api.prototype.getLoginProvidersWeChatExternalAccountPlatforms = function (unionId, xTenantContext, options, callback) {
        return this.sendOperationRequest({
            unionId: unionId,
            xTenantContext: xTenantContext,
            options: options
        }, getLoginProvidersWeChatExternalAccountPlatformsOperationSpec, callback);
    };
    Api.prototype.createLoginProvidersWeChatExternalAccountPlatform = function (unionId, xTenantContext, options, callback) {
        return this.sendOperationRequest({
            unionId: unionId,
            xTenantContext: xTenantContext,
            options: options
        }, createLoginProvidersWeChatExternalAccountPlatformOperationSpec, callback);
    };
    Api.prototype.getCustomerWellnessClubs = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerWellnessClubsOperationSpec, callback);
    };
    Api.prototype.createCustomerWellnessClubTypeWellnessClub = function (xTenantContext, customerId, clubType, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            clubType: clubType,
            options: options
        }, createCustomerWellnessClubTypeWellnessClubOperationSpec, callback);
    };
    Api.prototype.getCustomerWellnessClubTypeWellnessClub = function (xTenantContext, customerId, clubType, clubId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            clubType: clubType,
            clubId: clubId,
            options: options
        }, getCustomerWellnessClubTypeWellnessClubOperationSpec, callback);
    };
    Api.prototype.updateCustomerWellnessClubTypeWellnessClub = function (xTenantContext, customerId, clubType, clubId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            clubType: clubType,
            clubId: clubId,
            options: options
        }, updateCustomerWellnessClubTypeWellnessClubOperationSpec, callback);
    };
    Api.prototype.deleteCustomerWellnessClubTypeWellnessClub = function (xTenantContext, customerId, clubType, clubId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            clubType: clubType,
            clubId: clubId,
            options: options
        }, deleteCustomerWellnessClubTypeWellnessClubOperationSpec, callback);
    };
    Api.prototype.createCustomerWellnessClubTypeWellnessClubMember = function (xTenantContext, customerId, clubType, clubId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            clubType: clubType,
            clubId: clubId,
            options: options
        }, createCustomerWellnessClubTypeWellnessClubMemberOperationSpec, callback);
    };
    Api.prototype.deleteCustomerWellnessClubTypeWellnessClubMember = function (xTenantContext, customerId, clubType, clubId, memberCustomerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            clubType: clubType,
            clubId: clubId,
            memberCustomerId: memberCustomerId,
            options: options
        }, deleteCustomerWellnessClubTypeWellnessClubMemberOperationSpec, callback);
    };
    Api.prototype.updateCustomerWellnessClubTypeWellnessClubMember = function (xTenantContext, customerId, clubType, clubId, memberCustomerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            clubType: clubType,
            clubId: clubId,
            memberCustomerId: memberCustomerId,
            options: options
        }, updateCustomerWellnessClubTypeWellnessClubMemberOperationSpec, callback);
    };
    Api.prototype.updateWellnessClubInvitationApproval = function (xTenantContext, invitationCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            invitationCode: invitationCode,
            options: options
        }, updateWellnessClubInvitationApprovalOperationSpec, callback);
    };
    Api.prototype.getWellnessClubInvitationDetails = function (xTenantContext, invitationCode, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            invitationCode: invitationCode,
            options: options
        }, getWellnessClubInvitationDetailsOperationSpec, callback);
    };
    Api.prototype.getApplicationsWellnessClubLocalization = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsWellnessClubLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsWellnessClubConfiguration = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, getApplicationsWellnessClubConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerWellnessLife = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, getCustomerWellnessLifeOperationSpec, callback);
    };
    Api.prototype.updateCustomerWellnessLife = function (xTenantContext, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            options: options
        }, updateCustomerWellnessLifeOperationSpec, callback);
    };
    return Api;
}(ApiContext));
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var createCustomerAcceptedTermOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/acceptedTerms",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAcceptedTermDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var updateAccountsMyChangePasswordOperationSpec = {
    httpMethod: "PUT",
    path: "accounts/my/changePassword",
    queryParameters: [
        Parameters.loginString
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalAccountsChangePasswordDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getAccountsMyOperationSpec = {
    httpMethod: "GET",
    path: "accounts/my",
    queryParameters: [
        Parameters.loginString
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAccountsAccountInfoDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createAccountsMySendTemporaryPasswordOperationSpec = {
    httpMethod: "POST",
    path: "accounts/my/sendTemporaryPassword",
    queryParameters: [
        Parameters.loginString,
        Parameters.channels
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateAccountsMyResetPasswordOperationSpec = {
    httpMethod: "PUT",
    path: "accounts/my/resetPassword",
    queryParameters: [
        Parameters.loginString
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalAccountsResetPasswordDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAccountsChangePasswordMetadataOperationSpec = {
    httpMethod: "GET",
    path: "accounts/changePasswordMetadata",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAccountsMetadataChangePasswordMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getAccountsMyPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "accounts/my/permissions",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAccountsPermissionsDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerActivationRequestOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/activationRequest",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersActivationRequestDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerAddressesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/addresses",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAddressesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerAddressOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/addresses",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xAddressFormContext,
        Parameters.xProcessContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAddressDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerAddressOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/addresses/{addressId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.addressId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xAddressFormContext,
        Parameters.xProcessContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAddressDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerAddressOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/addresses/{addressId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.addressId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerAddressesMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/addressesMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xAddressFormContext,
        Parameters.xProcessContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataAddressMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAddressFormatsOperationSpec = {
    httpMethod: "GET",
    path: "addressFormats",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAddressFormatCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getAddressFormatOperationSpec = {
    httpMethod: "GET",
    path: "addressFormats/{type}",
    urlParameters: [
        Parameters.type0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAddressFormatDto
        },
        default: {}
    },
    serializer: serializer
};
var getPaymentPaymentProvidersAdyenPaymentMethodsOperationSpec = {
    httpMethod: "GET",
    path: "payments/{onlinePaymentId}/paymentProviders/adyen/paymentMethods",
    urlParameters: [
        Parameters.onlinePaymentId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xPaymentChannel,
        Parameters.xPaymentShopperLocale,
        Parameters.xPaymentApiVersion
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentsAdyenPaymentMethodsResponseDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createPaymentPaymentProvidersAdyenPaymentOperationSpec = {
    httpMethod: "POST",
    path: "payments/{onlinePaymentId}/paymentProviders/adyen/payments",
    urlParameters: [
        Parameters.onlinePaymentId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xPaymentChannel,
        Parameters.xPaymentShopperLocale,
        Parameters.xPaymentApiVersion
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalPaymentsAdyenPaymentRequestDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentsAdyenPaymentResponseDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createPaymentPaymentProvidersAdyenPaymentDetailOperationSpec = {
    httpMethod: "POST",
    path: "payments/{onlinePaymentId}/paymentProviders/adyen/paymentDetails",
    urlParameters: [
        Parameters.onlinePaymentId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xPaymentApiVersion
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: {
            serializedName: "body",
            type: {
                name: "String"
            }
        }
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentsAdyenPaymentResponseDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPaymentPaymentProvidersAdyenClientCredentialsOperationSpec = {
    httpMethod: "GET",
    path: "payments/{onlinePaymentId}/paymentProviders/adyen/clientCredentials",
    urlParameters: [
        Parameters.onlinePaymentId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentsAdyenClientCredentialsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerPaymentProvidersAdyenContractDisableRequestOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/paymentProviders/adyen/contractDisableRequest",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xPaymentApiVersion
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAdyenContractDisableRequestDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAdyenContractDisableResponseDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationAnalyticsOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/{registrationId}/analytics",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomerRegistrationsAnalyticsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerApprovalOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/approval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedApprovalDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerApprovalOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/approval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedApprovalDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerApprovalMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/approvalMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerApprovalMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAtpClusterAtpOperationSpec = {
    httpMethod: "GET",
    path: "atpClusters/{atpClusterId}/atps/{itemCode}",
    urlParameters: [
        Parameters.atpClusterId0,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAtpClusterAtpsOperationSpec = {
    httpMethod: "GET",
    path: "atpClusters/{atpClusterId}/atps",
    urlParameters: [
        Parameters.atpClusterId0
    ],
    queryParameters: [
        Parameters.itemCodes
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAtpClusterOperationSpec = {
    httpMethod: "GET",
    path: "atpClusters/{atpClusterId}",
    urlParameters: [
        Parameters.atpClusterId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAtpClustersOperationSpec = {
    httpMethod: "GET",
    path: "atpClusters",
    queryParameters: [
        Parameters.deliveryChannelId0,
        Parameters.customerId1,
        Parameters.addressId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerAutoshipConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/autoshipConfiguration",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerAutoshipAvailabilitiesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/autoshipAvailabilities",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.products
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerAutoshipTypesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/autoshipTypes",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.product
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAutoshipTypesDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerAutoshipLegalArticlesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/autoshipLegalArticles",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAutoshipLegalArticlesDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerAutoshipInstructionOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/autoshipInstructions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xReferer,
        Parameters.xPlacement
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAutoshipInstructionDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAutoshipInstructionDto
        },
        default: {}
    },
    serializer: serializer
};
var getConceptAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "concepts/{conceptCode}/availability",
    urlParameters: [
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptAvailabilityDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptsAvailabilitiesOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/concepts/availabilities",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsAvailabilitiesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsAvailabilityDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getConceptsAvailabilitiesOperationSpec = {
    httpMethod: "POST",
    path: "concepts/availabilities",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsAvailabilitiesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsAvailabilityDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/concepts/{conceptCode}/availability",
    urlParameters: [
        Parameters.customerId0,
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptAvailabilityDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/products/{productCode}/availability",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "products/{productCode}/availability",
    urlParameters: [
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductsAvailabilityOperationSpec = {
    httpMethod: "POST",
    path: "products/availability",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsProductAvailabilityQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsAvailabilityOperationSpec = {
    httpMethod: "POST",
    path: "customer/{customerId}/products/availability",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsProductAvailabilityQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getBackInStockNotificationsOperationSpec = {
    httpMethod: "GET",
    path: "backInStockNotifications",
    queryParameters: [
        Parameters.productCodes0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var createBackInStockNotificationSubscriptionOperationSpec = {
    httpMethod: "POST",
    path: "backInStockNotificationSubscriptions",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationSubscriptionDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getBackInStockNotificationsConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "backInStockNotificationsConfiguration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationsConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerBackInStockNotificationsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/backInStockNotifications",
    urlParameters: [
        Parameters.customerId2
    ],
    queryParameters: [
        Parameters.productCodes0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerBackInStockNotificationSubscriptionOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/backInStockNotificationSubscriptions",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationSubscriptionDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerBankAccountApprovalsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/bankAccountApprovals",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.bankAccountId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersBankAccountApprovalsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerBankAccountsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/bankAccounts",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.includeTemporary
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersBankAccountsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerBankAccountOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/bankAccounts",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersBankAccountDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerBankAccountOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/bankAccounts/{bankAccountId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.bankAccountId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersBankAccountDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerBankAccountOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/bankAccounts/{bankAccountId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.bankAccountId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerBankAccountsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/bankAccountsMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataBankAccountMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerBankAccountAuthorizationRequestOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/bankAccounts/{bankAccountId}/authorizationRequest",
    urlParameters: [
        Parameters.customerId0,
        Parameters.bankAccountId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersBankAccountAuthorizationRequestDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getBankBranchesOperationSpec = {
    httpMethod: "GET",
    path: "bankBranches",
    queryParameters: [
        Parameters.market,
        Parameters.country0,
        Parameters.region,
        Parameters.province,
        Parameters.district,
        Parameters.area,
        Parameters.city,
        Parameters.locality,
        Parameters.street,
        Parameters.zipCode,
        Parameters.name0,
        Parameters.bankId0,
        Parameters.bankBranchIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFinanceBankBranchesDto
        },
        default: {}
    },
    serializer: serializer
};
var getBankBranchOperationSpec = {
    httpMethod: "GET",
    path: "bankBranches/{bankBranchId}",
    urlParameters: [
        Parameters.bankBranchId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFinanceBankBranchDto
        },
        default: {}
    },
    serializer: serializer
};
var getBanksOperationSpec = {
    httpMethod: "GET",
    path: "banks",
    queryParameters: [
        Parameters.bankIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFinanceBanksDto
        },
        default: {}
    },
    serializer: serializer
};
var getBankOperationSpec = {
    httpMethod: "GET",
    path: "banks/{bankId}",
    urlParameters: [
        Parameters.bankId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFinanceBankDto
        },
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionBasketOfferOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/basketOffers/{offerId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionBasketOfferOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/basketOffers/{offerId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingOfferChoicesDto
    },
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionBasketOffersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/basketOffers",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.top0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingBasketOffersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getBlockingCodesOperationSpec = {
    httpMethod: "GET",
    path: "blockingCodes",
    queryParameters: [
        Parameters.blockingType,
        Parameters.blockingCodeIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBlockingCodesBlockingCodesDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerBlockingsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/blockings",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.blockingState,
        Parameters.blockingCodeIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersBlockingsDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerBlockingOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/blockings/{blockingId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.blockingId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerBranchOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/branch",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerBranchDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerBranchOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/branch",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerBranchDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerBranchMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/branchMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerBranchMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getBranchesOperationSpec = {
    httpMethod: "GET",
    path: "branches",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBranchesBranchesDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getBranchOperationSpec = {
    httpMethod: "GET",
    path: "branches/{branchId}",
    urlParameters: [
        Parameters.branchId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBranchesBranchDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getBrandsOperationSpec = {
    httpMethod: "GET",
    path: "brands",
    queryParameters: [
        Parameters.categoryId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsBrandsDto
        },
        default: {}
    },
    serializer: serializer
};
var createCallInteractionOperationSpec = {
    httpMethod: "POST",
    path: "callInteractions",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCallInteractionsCallInteractionDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCampaignPointsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/{campaignId}/points",
    urlParameters: [
        Parameters.campaignId
    ],
    queryParameters: [
        Parameters.customerId3
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignPointsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCampaignRecruitPointsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/{campaignId}/recruitPoints",
    urlParameters: [
        Parameters.campaignId
    ],
    queryParameters: [
        Parameters.customerId3
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignPeriodsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCampaignsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns",
    queryParameters: [
        Parameters.campaignType0,
        Parameters.customerId1,
        Parameters.potentialQualification
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCampaignOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/{campaignId}",
    urlParameters: [
        Parameters.campaignId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCampaignsWelcomeProgramTargetsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/welcomeProgram/targets",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignTargetsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCampaignsWelcomeProgramBenefitsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/welcomeProgram/{step}/benefits",
    urlParameters: [
        Parameters.step
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignBenefitsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCampaignsActivityProgramTargetsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/activityProgram/targets",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignTargetsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerCampaignBenefitsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/campaigns/{campaignType}/benefits",
    urlParameters: [
        Parameters.customerId0,
        Parameters.campaignType1
    ],
    queryParameters: [
        Parameters.productCodes1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsCampaignBenefitsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerReportsCampaignPointsByOrdersOperationSpec = {
    httpMethod: "GET",
    path: "customer/{customerId}/reports/campaignPointsByOrders",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.periodId0,
        Parameters.filters,
        Parameters.sort,
        Parameters.includeTotalCountInResult,
        Parameters.skip0,
        Parameters.take0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalReportsCampaignPointsByOrdersReport
        },
        default: {}
    },
    serializer: serializer
};
var getCataloguesCatalogueContentOperationSpec = {
    httpMethod: "GET",
    path: "catalogues/catalogue/{catalogueCode}/content",
    urlParameters: [
        Parameters.catalogueCode1
    ],
    queryParameters: [
        Parameters.catalogueCode,
        Parameters.itemCode1,
        Parameters.pageIndex
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCatalogueContentDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsCatalogueIPaperCustomerConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/catalogueIPaper/customers/{customerId}/configuration",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsCatalogueIPaperConfigurationCatalogueIPaperConfigurationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCatalogueCatalogueItemOperationSpec = {
    httpMethod: "GET",
    path: "catalogues/{catalogueId}/catalogueItems/{catalogueItemId}",
    urlParameters: [
        Parameters.catalogueId,
        Parameters.catalogueItemId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCatalogueItemDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCatalogueCatalogueItemsOperationSpec = {
    httpMethod: "GET",
    path: "catalogues/{catalogueId}/catalogueItems",
    urlParameters: [
        Parameters.catalogueId
    ],
    queryParameters: [
        Parameters.isStandardItem,
        Parameters.itemCodes,
        Parameters.skip1,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCatalogueItemsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCatalogueOffersOperationSpec = {
    httpMethod: "GET",
    path: "catalogueOffers",
    queryParameters: [
        Parameters.purchaseItemCode,
        Parameters.benefitItemCode,
        Parameters.top0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCatalogueOffersDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var getCataloguesDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "catalogues",
    queryParameters: [
        Parameters.periodId0,
        Parameters.typeCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCataloguesDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getSocialMediaLibraryCategoryOperationSpec = {
    httpMethod: "GET",
    path: "socialMediaLibrary/categories/{categoryId}",
    urlParameters: [
        Parameters.categoryId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryCategoryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getSocialMediaLibraryCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "socialMediaLibrary/categories",
    queryParameters: [
        Parameters.search,
        Parameters.top2,
        Parameters.skip1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryCategoriesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "categories",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsCategoriesDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsChatBotConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/chatBot/configuration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsChatBotChatBotConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsClaimsSpaCatalogueItemsSearchOperationSpec = {
    httpMethod: "GET",
    path: "applications/claimsSpa/catalogueItemsSearch",
    queryParameters: [
        Parameters.productCodes0,
        Parameters.customerId3,
        Parameters.periodId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsClaimsCatalogueItemsSearchCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getConceptLabelsOperationSpec = {
    httpMethod: "GET",
    path: "conceptLabels",
    queryParameters: [
        Parameters.conceptCodes,
        Parameters.conceptLabelDomains
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getConceptsOperationSpec = {
    httpMethod: "POST",
    path: "concepts",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsDto
        },
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getConceptOperationSpec = {
    httpMethod: "GET",
    path: "concepts/{conceptCode}",
    urlParameters: [
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createApplicationsConcernReportFormOperationSpec = {
    httpMethod: "POST",
    path: "applications/concernReportForm",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConcernReportFormConcernReportFormDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSocialMediaLibraryConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/socialMediaLibrary/configuration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSocialMediaLibraryConfigurationDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerConfirmationOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/confirmation",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersConfirmationDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getLoginProvidersWeChatExternalAccountConnectedUserOperationSpec = {
    httpMethod: "GET",
    path: "login/providers/weChat/externalAccount/{unionId}/connectedUser",
    urlParameters: [
        Parameters.unionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalLoginConnectedUserDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getConsultantTitlesOperationSpec = {
    httpMethod: "GET",
    path: "consultantTitles",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConsultantsTitlesDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationContactDetailsOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/{registrationId}/contactDetails",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomerRegistrationsRegistrationContactDetailsDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerRegistrationContactDetailsOperationSpec = {
    httpMethod: "PUT",
    path: "customerRegistrations/{registrationId}/contactDetails",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomerRegistrationsRegistrationContactDetailsDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerRegistrationContactDetailsConfirmationOperationSpec = {
    httpMethod: "POST",
    path: "customerRegistrations/{registrationId}/contactDetails/confirmation",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomerRegistrationsRegistrationContactDetailsConfirmationDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getConsultantCustomerIdOperationSpec = {
    httpMethod: "GET",
    path: "consultants/{consultantNumber}/customerId",
    urlParameters: [
        Parameters.consultantNumber
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConsultantNumberOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/consultantNumber",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConsultantNumberDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customer/{customerId}/consultantNumber",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getConsultantCustomerIdDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "consultant/{consultantNumber}/customerId",
    urlParameters: [
        Parameters.consultantNumber
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptLabelsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/conceptLabels",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.conceptCodes,
        Parameters.conceptLabelDomains
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerInfoOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/info",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerInfoDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerInfoMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/infoMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerInfoMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerWelcomeProgramOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/welcomeProgram",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersWelcomeProgramDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerActivityProgramOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/activityProgram",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersActivityProgramDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRecruitmentCampaignOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/recruitmentCampaign",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRecruitmentCampaignDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalSalesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalSales",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalSalesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalSalesHistoryOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalSalesHistory",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerPersonalSalesHistoryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerLoyaltyProgramOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/loyaltyProgram",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersLoyaltyProgramDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerNewsletterSubscriptionOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/newsletterSubscriptions",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNewsletterSubscriptionsNewsletterSubscriptionsDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNewsletterSubscriptionsNewsletterSubscriptionStatusDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsLabelsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/productsLabels",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.productLabelDomains,
        Parameters.atpClusterId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRequiredTermsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/requiredTerms",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.termsType
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRequiredTermsDto
        },
        default: {}
    },
    serializer: serializer
};
var createReportsCustomerStatusOperationSpec = {
    httpMethod: "POST",
    path: "reports/customerStatuses",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalReportsCustomerStatusesRequestDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalReportsCustomerStatusesResponseDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerCustomerStatusOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/customerStatus",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerStatusDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerCustomerStatusOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/customerStatus",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerStatusDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerCustomerStatusMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/customerStatusMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerStatusMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerLocalConsultantTitleOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/localConsultantTitle",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersLocalConsultantTitleDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getDigitalDocumentsOperationSpec = {
    httpMethod: "GET",
    path: "digitalDocuments",
    queryParameters: [
        Parameters.folderId,
        Parameters.folderPath,
        Parameters.owner,
        Parameters.documentName,
        Parameters.metadata,
        Parameters.sorting,
        Parameters.skipCount,
        Parameters.maxResultCount
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDdlPagedResultDto1GlobalDdlDocumentDtoGlobalVersion1000CultureneutralPublicKeyTokennull
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getDigitalDocumentOperationSpec = {
    httpMethod: "GET",
    path: "digitalDocuments/{id}",
    urlParameters: [
        Parameters.id
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDdlPagedResultDto1GlobalDdlDocumentDtoGlobalVersion1000CultureneutralPublicKeyTokennull
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDigitalDocumentContentOperationSpec = {
    httpMethod: "GET",
    path: "digitalDocuments/{id}/contents/{contentId}",
    urlParameters: [
        Parameters.id,
        Parameters.contentId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDigitalDocumentLatestContentOperationSpec = {
    httpMethod: "GET",
    path: "digitalDocuments/{id}/latestContent",
    urlParameters: [
        Parameters.id
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDeliveryAddressOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/deliveryAddresses/{deliveryAddressId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.deliveryAddressId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDeliveryAddressDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDeliveryChannelOperationSpec = {
    httpMethod: "GET",
    path: "deliveryChannels/{deliveryChannelId}",
    urlParameters: [
        Parameters.deliveryChannelId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDeliveryDeliveryChannelDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDeliveryChannelAddressOperationSpec = {
    httpMethod: "GET",
    path: "deliveryChannels/{deliveryChannelId}/address",
    urlParameters: [
        Parameters.deliveryChannelId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedAddressDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDeliveryChannelCoordinatesOperationSpec = {
    httpMethod: "GET",
    path: "deliveryChannels/{deliveryChannelId}/coordinates",
    urlParameters: [
        Parameters.deliveryChannelId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedCoordinatesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryChannelsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/deliveryChannels",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.searchTerm,
        Parameters.method,
        Parameters.latitude,
        Parameters.longitude,
        Parameters.radius,
        Parameters.skip1,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryChannelsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionClusteredPickupPointsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/clusteredPickupPoints",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.north,
        Parameters.east,
        Parameters.south,
        Parameters.west,
        Parameters.zoom,
        Parameters.searchTerm,
        Parameters.method
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingClusteredPickupPointsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryChannelOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/deliveryChannels/{deliveryChannelId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.deliveryChannelId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryChannelDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryMethodsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/deliveryMethods",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryMethodsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryFiltersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/deliveryFilters",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.filterGroup
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryFiltersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryOptionsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/deliveryOptions",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.filter,
        Parameters.skip1,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryOptionsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/delivery",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionDeliveryOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/delivery",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingDeliveryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCourierWayBillNumberDeliveryStatusOperationSpec = {
    httpMethod: "POST",
    path: "couriers/{courierId}/wayBillNumbers/{wayBillNumber}/deliveryStatuses",
    urlParameters: [
        Parameters.courierId,
        Parameters.wayBillNumber
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalDeliveryDeliveryStatusDto
    },
    responses: {
        202: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerDocumentOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/documents",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.documentTypeId,
        Parameters.isTemporary
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    formDataParameters: [
        Parameters.file
    ],
    contentType: "multipart/form-data",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        415: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentImageOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documents/{documentId}/image",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentId
    ],
    queryParameters: [
        Parameters.width,
        Parameters.height
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documents/{documentId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerDocumentOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/documents/{documentId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentsInfosOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documents/infos",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.documentIds,
        Parameters.documentTypeId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersDocumentInfoDto"
                        }
                    }
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDocumentTypesOperationSpec = {
    httpMethod: "GET",
    path: "documentTypes",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersDocumentTypeDto"
                        }
                    }
                }
            }
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var createDocumentOperationSpec = {
    httpMethod: "POST",
    path: "documents",
    queryParameters: [
        Parameters.documentTypeId,
        Parameters.isTemporary
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    formDataParameters: [
        Parameters.file
    ],
    contentType: "multipart/form-data",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        415: {},
        default: {}
    },
    serializer: serializer
};
var getDocumentImageOperationSpec = {
    httpMethod: "GET",
    path: "documents/{documentId}/image",
    urlParameters: [
        Parameters.documentId
    ],
    queryParameters: [
        Parameters.width,
        Parameters.height
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDocumentOperationSpec = {
    httpMethod: "GET",
    path: "documents/{documentId}",
    urlParameters: [
        Parameters.documentId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDocumentsInfosOperationSpec = {
    httpMethod: "GET",
    path: "documents/infos",
    queryParameters: [
        Parameters.documentIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersDocumentInfoDto"
                        }
                    }
                }
            }
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentApprovalsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documentApprovals",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.approvalStates,
        Parameters.documentIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDocumentApprovalsDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerDocumentApprovalOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/documentApprovals",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersDocumentApprovalDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentApprovalOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documentApprovals/{documentApprovalId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentApprovalId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDocumentApprovalDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerDownlineCustomersOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/downlineCustomers",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.consultantNumberPrefix
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xDownlinePermission
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDownlineCustomersDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerDownlinePerformanceOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/downlinePerformance",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.periodId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalKpisDownlinePerformanceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDownlineSummaryOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/downlineSummary",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.downlineType,
        Parameters.periodId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDownlineSummaryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getEditorialArticlesOperationSpec = {
    httpMethod: "GET",
    path: "editorialArticles",
    queryParameters: [
        Parameters.articleType,
        Parameters.productCodes0,
        Parameters.relatedArticlesUrls,
        Parameters.skip0,
        Parameters.top3
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalEditorialArticlesEditorialArticlesDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsEInvoiceLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/eInvoice/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerEInvoiceApprovalOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/eInvoiceApproval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerBooleanDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerEInvoiceApprovalOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/eInvoiceApproval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerBooleanDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerEmailsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/emails",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEmailsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerEmailOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/emails",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEmailDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerEmailOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/emails/{emailAddress}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.emailAddress
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEmailsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/emailsMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataEmailMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEmailVerificationRequestOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/emails/{emailAddress}/verificationRequest",
    urlParameters: [
        Parameters.customerId0,
        Parameters.emailAddress
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEmailVerificationRequestDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerEmailVerificationRequestOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/emails/{emailAddress}/verificationRequest",
    urlParameters: [
        Parameters.customerId0,
        Parameters.emailAddress
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEmailVerificationRequestDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getEndConsumerOrderItemOperationSpec = {
    httpMethod: "GET",
    path: "endConsumerOrders/{endConsumerOrderId}/items/{itemCode}",
    urlParameters: [
        Parameters.endConsumerOrderId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalEndConsumerOrdersEndConsumerOrderItemDto
        },
        default: {}
    },
    serializer: serializer
};
var updateEndConsumerOrderItemOperationSpec = {
    httpMethod: "PUT",
    path: "endConsumerOrders/{endConsumerOrderId}/items/{itemCode}",
    urlParameters: [
        Parameters.endConsumerOrderId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalEndConsumerOrdersEndConsumerOrderItemDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var deleteEndConsumerOrderItemOperationSpec = {
    httpMethod: "DELETE",
    path: "endConsumerOrders/{endConsumerOrderId}/items/{itemCode}",
    urlParameters: [
        Parameters.endConsumerOrderId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var createEndConsumerOrderItemOperationSpec = {
    httpMethod: "POST",
    path: "endConsumerOrders/{endConsumerOrderId}/items",
    urlParameters: [
        Parameters.endConsumerOrderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalEndConsumerOrdersEndConsumerOrderItemDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var createEndConsumerOrderOperationSpec = {
    httpMethod: "POST",
    path: "endConsumerOrders",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalEndConsumerOrdersEndConsumerOrderDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getEndConsumerOrdersOperationSpec = {
    httpMethod: "GET",
    path: "endConsumerOrders",
    queryParameters: [
        Parameters.customerId1,
        Parameters.orderStatus
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalEndConsumerOrdersEndConsumerOrdersDto
        },
        default: {}
    },
    serializer: serializer
};
var getEndConsumerOrderOperationSpec = {
    httpMethod: "GET",
    path: "endConsumerOrders/{endConsumerOrderId}",
    urlParameters: [
        Parameters.endConsumerOrderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalEndConsumerOrdersEndConsumerOrderDto
        },
        default: {}
    },
    serializer: serializer
};
var createEndConsumerOrderApprovalOperationSpec = {
    httpMethod: "POST",
    path: "endConsumerOrders/{endConsumerOrderId}/approval",
    urlParameters: [
        Parameters.endConsumerOrderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var deleteEndConsumerOrderApprovalOperationSpec = {
    httpMethod: "DELETE",
    path: "endConsumerOrders/{endConsumerOrderId}/approval",
    urlParameters: [
        Parameters.endConsumerOrderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEndConsumersOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/endConsumers",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEndConsumersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerEndConsumerOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/endConsumers",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEndConsumerDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEndConsumerOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/endConsumers/{endConsumerId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.endConsumerId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEndConsumerDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerEndConsumerOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/endConsumers/{endConsumerId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.endConsumerId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEndConsumerDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerEndConsumerOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/endConsumers/{endConsumerId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.endConsumerId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getEndConsumersMetadataOperationSpec = {
    httpMethod: "GET",
    path: "endConsumersMetadata",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataEndConsumerMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsEndCustomerReferralDiscountLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/endCustomerReferralDiscount/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var createEndCustomerOperationSpec = {
    httpMethod: "POST",
    path: "endCustomers",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEndCustomerDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getEndCustomersMetadataOperationSpec = {
    httpMethod: "GET",
    path: "endCustomersMetadata",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataEndCustomerMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getSystemEndpointsIdentityServerDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "system/endpoints/identityServer",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSystemIdentityServerEndpointsDto
        },
        default: {}
    },
    serializer: serializer
};
var getSystemEndpointsOnlineDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "system/endpoints/online",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSystemOnlineEndpointsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerEWalletAccountsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/eWalletAccounts",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEWalletAccountsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerEWalletAccountOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/eWalletAccounts",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEWalletAccountDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerEWalletAccountOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/eWalletAccounts/{eWalletAccountId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.eWalletAccountId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEWalletAccountDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerEWalletAccountOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/eWalletAccounts/{eWalletAccountId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.eWalletAccountId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEWalletAccountsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/eWalletAccountsMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataEWalletAccountMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerExternalAccountsWeChatUnionIdOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/externalAccounts/weChat/unionId",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersWeChatUnionIdDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerExternalProfilesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/externalProfiles",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalAccountsExternalProfileDto"
                        }
                    }
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerExternalAccountOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/externalAccounts/{externalProvider}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.externalProvider
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getFeatureToggleOperationSpec = {
    httpMethod: "GET",
    path: "featureToggles/{featureId}",
    urlParameters: [
        Parameters.featureId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.DtosFeatureTogglesFeatureToggleDto
        },
        default: {}
    },
    serializer: serializer
};
var getFeatureTogglesOperationSpec = {
    httpMethod: "GET",
    path: "featureToggles",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFeatureTogglesFeatureToggleCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerFinancialSetOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/financialSet",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersFinancialSetDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductsFormattedPricesOperationSpec = {
    httpMethod: "GET",
    path: "productsFormattedPrices",
    queryParameters: [
        Parameters.productCodes1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductFormattedPricesDto
        },
        default: {}
    },
    serializer: serializer
};
var getConceptsFormattedPricesOperationSpec = {
    httpMethod: "GET",
    path: "conceptsFormattedPrices",
    queryParameters: [
        Parameters.conceptCodes
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsConceptFormattedPricesDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsOriflameAppFrontPageBannersOperationSpec = {
    httpMethod: "GET",
    path: "applications/oriflameApp/frontPageBanners",
    queryParameters: [
        Parameters.thumbnailSize,
        Parameters.thumbnailQuality
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsOriflameAppFrontPageBannersDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsOriflameAppFrontPageBannerOperationSpec = {
    httpMethod: "GET",
    path: "applications/oriflameApp/frontPageBanners/{frontPageBannerId}",
    urlParameters: [
        Parameters.frontPageBannerId
    ],
    queryParameters: [
        Parameters.thumbnailSize,
        Parameters.thumbnailQuality
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsOriflameAppFrontPageBannerDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsFrontpageCustomerBenefitBannerOperationSpec = {
    httpMethod: "GET",
    path: "applications/frontpage/customers/{customerId}/benefitBanner",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsFrontpageV3BenefitBannerDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsGenesysWidgetOperationSpec = {
    httpMethod: "GET",
    path: "applications/genesysWidget",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsGenesysWidgetGenesysWidgetConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerGrantedCreditOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/grantedCredit",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersGrantedCreditDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerGrantedCreditOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/grantedCredit",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersGrantedCreditDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerGuaranteeCreditOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/guaranteeCredit",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersGuaranteeCreditDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsGuaranteeCreditLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/guaranteeCredit/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsGuaranteeCreditGrantedCreditConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/guaranteeCredit/grantedCreditConfiguration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalGuaranteeCreditGrantedCreditConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsGuaranteeCreditCustomersOperationSpec = {
    httpMethod: "GET",
    path: "applications/guaranteeCredit/customers",
    queryParameters: [
        Parameters.hint,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalGuaranteeCreditGuaranteeCreditCustomersDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionHomeDeliveryOptionsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/homeDeliveryOptions",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingHomeDeliveryOptionsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerIdentityCardOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/identityCard",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersIdentityCardDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerIdentityCardOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/identityCard",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersIdentityCardDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getSocialMediaLibraryImageInfoOperationSpec = {
    httpMethod: "GET",
    path: "socialMediaLibrary/imageInfos/{imageInfoId}",
    urlParameters: [
        Parameters.imageInfoId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryImageInfoDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getSocialMediaLibraryImageInfosOperationSpec = {
    httpMethod: "GET",
    path: "socialMediaLibrary/imageInfos",
    queryParameters: [
        Parameters.search,
        Parameters.top2,
        Parameters.skip1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryImageInfosDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getInAppNotificationsOperationSpec = {
    httpMethod: "GET",
    path: "inAppNotifications",
    queryParameters: [
        Parameters.since,
        Parameters.take1,
        Parameters.sortType,
        Parameters.continuationToken
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication,
        Parameters.acceptLanguage0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsInAppNotificationsDto
        },
        default: {}
    },
    serializer: serializer
};
var getInAppNotificationUpdatesOperationSpec = {
    httpMethod: "GET",
    path: "inAppNotificationUpdates",
    queryParameters: [
        Parameters.since,
        Parameters.take1
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication,
        Parameters.acceptLanguage0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsInAppNotificationsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerInAppNotificationsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/inAppNotifications",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.since,
        Parameters.take1,
        Parameters.sortType,
        Parameters.continuationToken
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsInAppNotificationsDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerInAppNotificationsOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/inAppNotifications",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.dueDate,
        Parameters.notificationType,
        Parameters.messageType
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication
    ],
    responses: {
        200: {},
        204: {},
        400: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerInAppNotificationUpdatesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/inAppNotificationUpdates",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.since,
        Parameters.take1
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsInAppNotificationsDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerInAppNotificationViewedOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/inAppNotifications/{notificationId}/viewed",
    urlParameters: [
        Parameters.notificationId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication,
        Parameters.xClientPlatform
    ],
    responses: {
        200: {},
        204: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerInAppNotificationsViewedOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/inAppNotifications/viewed",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.dueDate,
        Parameters.notificationType,
        Parameters.messageType
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication,
        Parameters.xClientPlatform
    ],
    responses: {
        200: {},
        204: {},
        400: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerInAppNotificationOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/inAppNotifications/{notificationId}",
    urlParameters: [
        Parameters.notificationId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication,
        Parameters.xClientPlatform
    ],
    responses: {
        200: {},
        204: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerInAppNotificationUndeleteOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/inAppNotifications/{notificationId}/undelete",
    urlParameters: [
        Parameters.notificationId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication
    ],
    responses: {
        200: {},
        204: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getNotificationMessageTypesOperationSpec = {
    httpMethod: "GET",
    path: "notificationMessageTypes",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsNotificationMessageTypesDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerInAppNotificationsSeenOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/inAppNotifications/seen",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.dueDate
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication,
        Parameters.xClientPlatform
    ],
    responses: {
        200: {},
        204: {},
        400: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerInAppNotificationSeenOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/inAppNotifications/{notificationId}/seen",
    urlParameters: [
        Parameters.notificationId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication,
        Parameters.xClientPlatform
    ],
    responses: {
        200: {},
        204: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerUnseenNotificationsCountOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/unseenNotificationsCount",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsCountDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var getIngredientsOperationSpec = {
    httpMethod: "GET",
    path: "ingredients",
    queryParameters: [
        Parameters.ingredientNames,
        Parameters.top3,
        Parameters.skip0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalIngredientLibraryIngredientsDto
        },
        default: {}
    },
    serializer: serializer
};
var getIngredientOperationSpec = {
    httpMethod: "GET",
    path: "ingredients/{ingredientName}",
    urlParameters: [
        Parameters.ingredientName
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalIngredientLibraryIngredientDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerInternationalInfoOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/internationalInfo",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersInternationalInfoInternationalInfoDto
        },
        default: {}
    },
    serializer: serializer
};
var getJoiningFeeDialogHtmlDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "joiningFeeDialog/html",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersJoiningFeeDialogHtmlDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationLegalDetailsOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/{registrationId}/legalDetails",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomerRegistrationsRegistrationLegalDetailsDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerRegistrationLegalDetailsOperationSpec = {
    httpMethod: "PUT",
    path: "customerRegistrations/{registrationId}/legalDetails",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomerRegistrationsRegistrationLegalDetailsDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerLegalDocumentOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/legalDocument",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.areaManager
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSocialMediaLibraryLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/socialMediaLibrary/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getLoginStatusOperationSpec = {
    httpMethod: "GET",
    path: "login/status",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalLoginLoginStatusDto
        },
        default: {}
    },
    serializer: serializer
};
var getAddressNodeDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "addressNodes/{nodeId}",
    urlParameters: [
        Parameters.nodeId0
    ],
    queryParameters: [
        Parameters.country1
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xMockResponse
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAddressesLookupAddressNodeDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getAddressSearchResultOperationSpec = {
    httpMethod: "GET",
    path: "addressSearchResults/{addressSearchResultId}",
    urlParameters: [
        Parameters.addressSearchResultId
    ],
    queryParameters: [
        Parameters.country1
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xMockResponse
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAddressesLookupAddressSearchResultDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getAddressSuggestionsOperationSpec = {
    httpMethod: "GET",
    path: "addressSuggestions",
    queryParameters: [
        Parameters.searchText,
        Parameters.pathKey,
        Parameters.country2,
        Parameters.top4
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAddressesLookupAddressSuggestionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardLooksOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/looks",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsMakeUpWizardLooksDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardLooktagsOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/looktags",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsMakeUpWizardTagsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/categories",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsMakeUpWizardMakeupWizardCategoriesDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardWelcomeScreenStepsOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/welcomeScreenSteps",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsMakeUpWizardWelcomeScreenStepsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerMaritalStatusOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/maritalStatus",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerSelectionDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerMaritalStatusOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/maritalStatus",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerSelectionDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCommissionPlansMatureMarketTitleQualificationsOperationSpec = {
    httpMethod: "GET",
    path: "commissionPlans/matureMarket/titleQualifications",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCommissionPlansTitleQualificationsMmDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerMenuOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/menu",
    urlParameters: [
        Parameters.customerId2
    ],
    queryParameters: [
        Parameters.rootLevelOnly,
        Parameters.orderType,
        Parameters.userHash
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsPersonalMenuPersonalMenuDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getMobileAppsLinksOperationSpec = {
    httpMethod: "GET",
    path: "mobileAppsLinks",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileAppsMobileAppsLinksDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsOriflameappMyPageOperationSpec = {
    httpMethod: "GET",
    path: "applications/oriflameapp/myPage",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsOriflameAppMyPageDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerNameBankContactsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/nameBankContacts",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.top4,
        Parameters.skip2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeNameBankNameBankContactsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNameBankContactOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/nameBankContacts",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalMobileOfficeNameBankNameBankContactDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        201: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerNameBankContactOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/nameBankContacts/{contactId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.contactId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeNameBankNameBankContactDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerNameBankContactOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/nameBankContacts/{contactId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.contactId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalMobileOfficeNameBankNameBankContactDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerNameBankContactOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/nameBankContacts/{contactId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.contactId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsNavigationNavigationOperationSpec = {
    httpMethod: "GET",
    path: "applications/navigation/navigations/{navigationType}",
    urlParameters: [
        Parameters.navigationType
    ],
    queryParameters: [
        Parameters.excludeChildren,
        Parameters.nodeId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNavigationNavigationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var createApplicationsNavigationSignalOperationSpec = {
    httpMethod: "POST",
    path: "applications/navigation/signal",
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.acceptLanguage0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductQuerySignalsDto
    },
    responses: {
        200: {},
        default: {}
    },
    serializer: serializer
};
var createApplicationsNavigationSignalsBulkOperationSpec = {
    httpMethod: "POST",
    path: "applications/navigation/signalsBulk",
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.acceptLanguage0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductQuerySignalsBulkDto
    },
    responses: {
        200: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsNavigationCustomerNavigationOperationSpec = {
    httpMethod: "GET",
    path: "applications/navigation/customers/{customerId}/navigations/{navigationType}",
    urlParameters: [
        Parameters.customerId2,
        Parameters.navigationType
    ],
    queryParameters: [
        Parameters.excludeChildren,
        Parameters.nodeId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNavigationNavigationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsNavigationCustomerInfoOperationSpec = {
    httpMethod: "GET",
    path: "applications/navigation/customers/{customerId}/info",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerInfoDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerNewsTopOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/news/top",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedPagingDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCmsArticleTeasersDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var createNewsletterSubscriptionOperationSpec = {
    httpMethod: "POST",
    path: "newsletterSubscriptions",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNewsletterSubscriptionsNewsletterSubscriptionsDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNewsletterSubscriptionsNewsletterSubscriptionStatusDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerNomineeOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/nominee",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersNomineeDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerNomineeOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/nominee",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersNomineeDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var createRelayNotificationsMobileOperationSpec = {
    httpMethod: "POST",
    path: "relayNotifications/mobile",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsMobileNotificationDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNotificationOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/notifications",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsCustomerNotificationDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsCustomerNotificationDto
        },
        400: {},
        403: {},
        409: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerNotificationOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/notifications/{notificationId}",
    urlParameters: [
        Parameters.customerId2,
        Parameters.notificationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        403: {},
        409: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerNotificationOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/notifications/{notificationId}",
    urlParameters: [
        Parameters.customerId2,
        Parameters.notificationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsCustomerNotificationDto
        },
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNotificationSendOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/notifications/{notificationId}/send",
    urlParameters: [
        Parameters.customerId2,
        Parameters.notificationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        409: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNotificationRecallOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/notifications/{notificationId}/recall",
    urlParameters: [
        Parameters.customerId2,
        Parameters.notificationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        403: {},
        409: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNotificationsSearchOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/notifications/search",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsCustomerNotificationSearchRequestDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsCustomerNotificationSearchResultDto
        },
        204: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomersNotificationsTargetsOperationSpec = {
    httpMethod: "GET",
    path: "customers/notifications/targets",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsTargetCollectionDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var getNotificationCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "notificationCategories",
    queryParameters: [
        Parameters.all
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsCategoriesDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerCustomerAttributeDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/customerAttributes/{customerAttributeTypeId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.customerAttributeTypeId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAttributeDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerCustomerAttributeDeprecatedOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/customerAttributes/{customerAttributeTypeId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.customerAttributeTypeId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAttributeDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerCustomerAttributesDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/customerAttributes",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAttributesDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOfferChoicesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferChoicesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionOfferChoicesOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingOfferChoicesDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferChoicesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionOfferChoicesOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionOfferChoiceOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingOfferChoiceDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOfferChoiceOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionOfferChoiceOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingOfferChoiceDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionOfferChoiceOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOfferOfferItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/offerItems",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    queryParameters: [
        Parameters.searchTerm,
        Parameters.isPurchased,
        Parameters.skip1,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferItemsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOffersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/offers",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOffersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerOnboardingOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/onboarding",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalOnboardingOnboardingDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerOnboardingOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/onboarding",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalOnboardingOnboardingDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerOnboardingMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/onboardingMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalOnboardingMetadataOnboardingMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerOnboardingTestOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/onboardingTest",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersOnboardingTestDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerOnboardingTestOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/onboardingTest",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersOnboardingTestDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTestsSmallSizeResponseOnlineOperationSpec = {
    httpMethod: "GET",
    path: "tests/smallSizeResponse/online",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTestsOnlineTestDataSetsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTestsMediumSizeResponseOnlineOperationSpec = {
    httpMethod: "GET",
    path: "tests/mediumSizeResponse/online",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTestsOnlineTestDataSetsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTestsBigSizeResponseOnlineOperationSpec = {
    httpMethod: "GET",
    path: "tests/bigSizeResponse/online",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTestsOnlineTestDataSetsDto
        },
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionOrderOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/order",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsOrderHistoryCustomerKpiOperationSpec = {
    httpMethod: "GET",
    path: "applications/orderHistory/customers/{customerId}/kpi",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsOrderHistoryOrderHistoryKpiDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsOrderHistoryCustomerConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/orderHistory/customers/{customerId}/configuration",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsOrderHistoryOrderHistoryConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getOrderItemsOperationSpec = {
    httpMethod: "GET",
    path: "orderItems",
    queryParameters: [
        Parameters.customerId1,
        Parameters.orderIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderItemsDto
        },
        default: {}
    },
    serializer: serializer
};
var getOrdersOperationSpec = {
    httpMethod: "GET",
    path: "orders",
    queryParameters: [
        Parameters.customerId1,
        Parameters.historyType,
        Parameters.status,
        Parameters.searchPhrase,
        Parameters.excludeWeChatOrders,
        Parameters.top3,
        Parameters.skip0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingOrderDto"
                        }
                    }
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createOrderOperationSpec = {
    httpMethod: "POST",
    path: "orders",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingOrderDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getOrderOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderDto
        },
        default: {}
    },
    serializer: serializer
};
var deleteOrderOperationSpec = {
    httpMethod: "DELETE",
    path: "orders/{orderId}",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {},
        default: {}
    },
    serializer: serializer
};
var getOrderOperationPrincipalsOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/operationPrincipals",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOperationPrincipalsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerOrdersLastUnpaidOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/orders/lastUnpaid",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.orderOriginType
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingUnpaidOrderDto
        },
        default: {}
    },
    serializer: serializer
};
var getOrderRealtimeOrderTrackingOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/realtimeOrderTracking",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderTrackingsDto
        },
        default: {}
    },
    serializer: serializer
};
var getOrderPaymentProviderOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/paymentProvider",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderPaymentProviderDto
        },
        default: {}
    },
    serializer: serializer
};
var updateOrderPaymentProviderOperationSpec = {
    httpMethod: "PUT",
    path: "orders/{orderId}/paymentProvider",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingOrderPaymentProviderDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderPaymentProviderDto
        },
        default: {}
    },
    serializer: serializer
};
var getOrderDiscountsOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/discounts",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedOrderDiscountsDto
        },
        default: {}
    },
    serializer: serializer
};
var getOrderEndConsumersOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/endConsumers",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEndConsumersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getOrderStatusesOperationSpec = {
    httpMethod: "GET",
    path: "orderStatuses",
    queryParameters: [
        Parameters.customerId1,
        Parameters.excludeWeChatOrders
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderStatusesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getOrderNavigationOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/navigation",
    urlParameters: [
        Parameters.orderId
    ],
    queryParameters: [
        Parameters.shortUrls
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalOrdersOrderNavigationDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsOrderSummaryOrderSummaryOperationSpec = {
    httpMethod: "GET",
    path: "applications/orderSummary/orders/{orderId}/summary",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsOrderSummaryOrderSummaryDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerOriflameCardOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/oriflameCard",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.cardResultType
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsOutdatedBrowserInfoLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/outdatedBrowserInfo/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getOrderPaymentMethodsOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/paymentMethods",
    urlParameters: [
        Parameters.orderId
    ],
    queryParameters: [
        Parameters.evaluationFilterType0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentMethodsPaymentMethodsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPaymentMethodsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/paymentMethods",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.isBlocked
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentMethodsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPaymentProvidersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/paymentProviders",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.evaluationFilterType1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentProvidersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPaymentProviderOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/paymentProviders/{paymentProviderId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.paymentProviderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentProvidersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPaymentProviderOperationSpec = {
    httpMethod: "GET",
    path: "paymentProviders/{paymentProviderId}",
    urlParameters: [
        Parameters.paymentProviderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentProvidersPaymentProviderDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getOrderPaymentProvidersOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/paymentProviders",
    urlParameters: [
        Parameters.orderId
    ],
    queryParameters: [
        Parameters.evaluationFilterType0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentProvidersPaymentProvidersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerOrderPaymentDatumOperationSpec = {
    httpMethod: "POST",
    path: "customer/{customerId}/order/{orderId}/paymentData",
    urlParameters: [
        Parameters.customerId0,
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentsPaymentDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerOrderSharedPaymentDatumOperationSpec = {
    httpMethod: "POST",
    path: "customer/{customerId}/order/{orderId}/sharedPaymentData",
    urlParameters: [
        Parameters.customerId0,
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPaymentsPaymentDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPaymentOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/payment",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionPaymentOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/payment",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingPaymentDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getOrderPendingPaymentsResultOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/pendingPaymentsResult",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalOrdersPendingPaymentsResultDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPendingRegistrationOperationSpec = {
    httpMethod: "GET",
    path: "pendingRegistrations/{pendingRegistrationId}",
    urlParameters: [
        Parameters.pendingRegistrationId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xProcessContext1
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPendingRegistrationsPendingRegistrationDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updatePendingRegistrationOperationSpec = {
    httpMethod: "PUT",
    path: "pendingRegistrations/{pendingRegistrationId}",
    urlParameters: [
        Parameters.pendingRegistrationId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xProcessContext1
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalPendingRegistrationsPendingRegistrationDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createPendingRegistrationOperationSpec = {
    httpMethod: "POST",
    path: "pendingRegistrations",
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xProcessContext1
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalPendingRegistrationsPendingRegistrationDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPendingRegistrationsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "pendingRegistrationsMetadata",
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xProcessContext1
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPendingRegistrationsPendingRegistrationMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPeriodOperationSpec = {
    httpMethod: "GET",
    path: "periods/{periodCode}",
    urlParameters: [
        Parameters.periodCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBonusesPeriodDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPeriodsOperationSpec = {
    httpMethod: "GET",
    path: "periods",
    queryParameters: [
        Parameters.offsets
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalBonusesPeriodDto"
                        }
                    }
                }
            }
        },
        400: {},
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPeriodsCurrentPeriodOperationSpec = {
    httpMethod: "GET",
    path: "periods/currentPeriod",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBonusesCurrentPeriodDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPeriodTasksOperationSpec = {
    httpMethod: "GET",
    path: "periods/{periodCode}/tasks",
    urlParameters: [
        Parameters.periodCode
    ],
    queryParameters: [
        Parameters.type1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBonusesPeriodTasksDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPeriodTaskOperationSpec = {
    httpMethod: "GET",
    path: "periods/{periodCode}/tasks/{taskId}",
    urlParameters: [
        Parameters.periodCode,
        Parameters.taskId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBonusesPeriodTaskDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getConceptsPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "concepts/permissions",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsPermissionsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsPermissionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getConceptPermissionOperationSpec = {
    httpMethod: "GET",
    path: "concepts/{conceptCode}/permission",
    urlParameters: [
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsPermissionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptsPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/concepts/permissions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsPermissionsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsPermissionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptPermissionOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/concepts/{conceptCode}/permission",
    urlParameters: [
        Parameters.customerId0,
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsPermissionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getProductsPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "products/permissions",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsPermissionsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsPermissionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getProductPermissionOperationSpec = {
    httpMethod: "GET",
    path: "products/{productCode}/permission",
    urlParameters: [
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsPermissionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductPermissionOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/products/{productCode}/permission",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsPermissionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/products/permissions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsPermissionsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsPermissionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRolesPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "customer/{customerId}/roles/permissions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersPermissionDto"
                        }
                    }
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalBeautyStoreOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalBeautyStore",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalBeautyStoreDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerPersonalBeautyStoreOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/personalBeautyStore",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPersonalBeautyStoreDto
    },
    responses: {
        200: {},
        201: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerPersonalBeautyStoreOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/personalBeautyStore",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPersonalBeautyStoreDto
    },
    responses: {
        201: {},
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalBeautyStoreMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalBeautyStore/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataPbsMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalBeautyStoreProfileOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalBeautyStore/profile",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalBeautyStoreProfileDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalBeautyStoreDynamiclinkOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalBeautyStore/dynamiclink",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.acceptLanguage1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDynamicLinksDynamicLinkDto
        },
        400: {},
        401: {},
        default: {}
    },
    serializer: serializer
};
var getPersonalBeautyStoreConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "personalBeautyStoreConfiguration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPersonalBeautyStoreConfigurationConfigurationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getPersonalBeautyStoreOperationSpec = {
    httpMethod: "GET",
    path: "personalBeautyStores/{name}",
    urlParameters: [
        Parameters.name1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalBeautyStoreDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationPersonalDetailsOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/{registrationId}/personalDetails",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomerRegistrationsRegistrationPersonalDetailsDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerRegistrationPersonalDetailsOperationSpec = {
    httpMethod: "PUT",
    path: "customerRegistrations/{registrationId}/personalDetails",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomerRegistrationsRegistrationPersonalDetailsDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalDocumentOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalDocument",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerDocumentsDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerPersonalDocumentOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/personalDocument",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerDocumentsDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalMenuLocalizationDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalMenu/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalMenuOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalMenu",
    queryParameters: [
        Parameters.rootLevelOnly,
        Parameters.orderType,
        Parameters.userHash,
        Parameters.onBehalfOfCustomerId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsPersonalMenuPersonalMenuDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalMenuOrisalesMenuOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalMenu/orisalesMenu",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsPersonalMenuOrisalesMenuDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalPerformanceOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalPerformance",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.periodId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalKpisPersonalPerformanceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalProductsListLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalProductsList/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalProductsListConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalProductsList/configuration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsPersonalProductsListConfigurationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPhonesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/phones",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPhonesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerPhoneOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/phones",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPhoneDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerPhoneOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/phones/{telephoneId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.telephoneId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPhoneDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerPhoneOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/phones/{telephoneId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.telephoneId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPhonesMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/phonesMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataTelephoneMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPhoneVerificationRequestOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/phones/{telephoneId}/verificationRequest",
    urlParameters: [
        Parameters.customerId0,
        Parameters.telephoneId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersTelephoneVerificationRequestDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerPhoneVerificationRequestOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/phones/{telephoneId}/verificationRequest",
    urlParameters: [
        Parameters.customerId0,
        Parameters.telephoneId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersTelephoneVerificationRequestDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPopularProductsOperationSpec = {
    httpMethod: "GET",
    path: "popularProducts",
    queryParameters: [
        Parameters.type0,
        Parameters.validityDate,
        Parameters.categoryId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPopularProductsProductCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerPreferencesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/preferences",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerPreferencesDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerPreferencesOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/preferences",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerPreferencesDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerPreferencesMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/preferencesMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerPreferencesMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerCheckoutPrerequisitesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/checkoutPrerequisites",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCheckoutPrerequisitesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getConceptsPricesOperationSpec = {
    httpMethod: "POST",
    path: "concepts/prices",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsConceptPricesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptPricesDto
        },
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getConceptPriceOperationSpec = {
    httpMethod: "GET",
    path: "concepts/{conceptCode}/price",
    urlParameters: [
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptPriceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptsPricesOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/concepts/prices",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsConceptPricesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptPricesDto
        },
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptPriceOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/concepts/{conceptCode}/price",
    urlParameters: [
        Parameters.customerId0,
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConsultantConceptPriceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getProductsPricesOperationSpec = {
    httpMethod: "POST",
    path: "products/prices",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsProductPricesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductPricesDto
        },
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductPriceOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/products/{productCode}/price",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsConsultantProductPriceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsPricesOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/products/prices",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsProductPricesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductPricesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getProductBundleOperationSpec = {
    httpMethod: "GET",
    path: "productBundles/{productCode}",
    urlParameters: [
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductBundleDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductBundlesOperationSpec = {
    httpMethod: "GET",
    path: "productBundles",
    queryParameters: [
        Parameters.includedProducts,
        Parameters.productCodes0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductBundlesDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductLabelsContentOperationSpec = {
    httpMethod: "GET",
    path: "productLabelsContent",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductLabelsContentCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductListTypeProductListOperationSpec = {
    httpMethod: "GET",
    path: "productListTypes/{productListType}/productLists/{productListId}",
    urlParameters: [
        Parameters.productListType0,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedProductListDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductListTypeProductListsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersProductListsDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerProductListTypeProductListOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedProductListDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedProductListDto
        },
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductListTypeProductListOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType0,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedProductListDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerProductListTypeProductListOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType0,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedProductListDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedProductListDto
        },
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerProductListTypeProductListOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType0,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {},
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerProductListTypeProductListItemOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/ProductListTypes/{productListType}/ProductLists/{productListId}/Items/{itemCode}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType0,
        Parameters.productListId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerProductListTypeProductListItemOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/ProductListTypes/{productListType}/ProductLists/{productListId}/Items",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType0,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedProductListItemDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductListTypeProductListDynamiclinkOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}/dynamiclink",
    urlParameters: [
        Parameters.customerId2,
        Parameters.productListId,
        Parameters.productListType1
    ],
    queryParameters: [
        Parameters.storename
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.acceptLanguage1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDynamicLinksDynamicLinkDto
        },
        400: {},
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsProductListingListingsOperationSpec = {
    httpMethod: "GET",
    path: "applications/productListing/listings",
    queryParameters: [
        Parameters.productListingPageId,
        Parameters.skip1,
        Parameters.top5
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductListingDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsProductListingPromoBannersOperationSpec = {
    httpMethod: "GET",
    path: "applications/productListing/promoBanners",
    queryParameters: [
        Parameters.ids
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductListingPromoBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductsOperationSpec = {
    httpMethod: "POST",
    path: "products",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductOperationSpec = {
    httpMethod: "GET",
    path: "products/{productCode}",
    urlParameters: [
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getProductsExpectedInboundsOperationSpec = {
    httpMethod: "GET",
    path: "productsExpectedInbounds",
    queryParameters: [
        Parameters.productCodes1,
        Parameters.atpClusterId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsExpectedInboundsProductsExpectedInboundsCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductsIngredientsOperationSpec = {
    httpMethod: "GET",
    path: "productsIngredients",
    queryParameters: [
        Parameters.productCodes1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsIngredientsProductsIngredientsDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductsLabelsOperationSpec = {
    httpMethod: "GET",
    path: "productsLabels",
    queryParameters: [
        Parameters.productCodes1,
        Parameters.productLabelDomains,
        Parameters.atpClusterId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsReplacementsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/productsReplacements",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.productCodes1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsReplacementsDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsShoppingBagProductsOperationSpec = {
    httpMethod: "GET",
    path: "applications/shoppingBag/products",
    queryParameters: [
        Parameters.hint,
        Parameters.customerId3,
        Parameters.periodId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsShoppingBagProductsSearchDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profile",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xProcessContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersProfileDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerProfileOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/profile",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xProcessContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersProfileDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profileMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xProcessContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataProfileMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileCompletenessOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profileCompleteness",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerProfileCompletenessDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileCompletenessMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profileCompletenessMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerProfileCompletenessMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerApplicationsProfileConfigurationsSectionsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/applications/profile/configurations/sections",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsProfileSectionsConfigurationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileApprovalOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profileApproval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersProfileApprovalDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileImageOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profileImage",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersProfileImageDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerProfileImageOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/profileImage",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersProfileImageDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileImageMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profileImageMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataProfileImageMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionOperationSpec = {
    httpMethod: "GET",
    path: "promotions/{promotionId}",
    urlParameters: [
        Parameters.promotionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPromotionsPromotionDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionBestOffersBannersOperationSpec = {
    httpMethod: "GET",
    path: "promotionBestOffersBanners",
    queryParameters: [
        Parameters.bannerIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDigitalPromotionsBestOffersBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionWhatsNewBannersOperationSpec = {
    httpMethod: "GET",
    path: "promotionWhatsNewBanners",
    queryParameters: [
        Parameters.bannerIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDigitalPromotionsWhatsNewBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionHeroBannersOperationSpec = {
    httpMethod: "GET",
    path: "promotionHeroBanners",
    queryParameters: [
        Parameters.bannerIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDigitalPromotionsHeroBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionCampaignBannersOperationSpec = {
    httpMethod: "GET",
    path: "promotionCampaignBanners",
    queryParameters: [
        Parameters.bannerIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDigitalPromotionsCampaignBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionCategoryBannersOperationSpec = {
    httpMethod: "GET",
    path: "promotionCategoryBanners",
    queryParameters: [
        Parameters.bannerIds
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDigitalPromotionsCategoryBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getDigitalPromotionsOperationSpec = {
    httpMethod: "GET",
    path: "digitalPromotions",
    queryParameters: [
        Parameters.promotionTypes,
        Parameters.channel,
        Parameters.validityDate
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDigitalPromotionsCurrentPromotionsDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionsOperationSpec = {
    httpMethod: "GET",
    path: "promotions",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPromotionsPromotionsDto
        },
        default: {}
    },
    serializer: serializer
};
var createPushNotificationsInstallationOperationSpec = {
    httpMethod: "POST",
    path: "pushNotifications/installations",
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.acceptLanguage0,
        Parameters.xClientApplication
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsInstallationRequestDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerPushNotificationsInstallationOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/pushNotifications/installations",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.acceptLanguage1,
        Parameters.xClientApplication
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsInstallationRequestDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var deleteCustomerPushNotificationsInstallationOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/pushNotifications/installations/{installationId}",
    urlParameters: [
        Parameters.customerId2,
        Parameters.installationId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xClientApplication
    ],
    responses: {
        200: {},
        204: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createPushNotificationsRegistrationOperationSpec = {
    httpMethod: "POST",
    path: "pushNotifications/registrations",
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xNotificationCentreApiKey
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsPushRegistrationDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var deletePushNotificationsApplicationRegistrationIdOperationSpec = {
    httpMethod: "DELETE",
    path: "pushNotifications/applications/{applicationKey}/registrationId/{registrationId}",
    urlParameters: [
        Parameters.applicationKey,
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xNotificationCentreApiKey
    ],
    responses: {
        200: {},
        204: {},
        default: {}
    },
    serializer: serializer
};
var deletePushNotificationsApplicationDeviceTokenOperationSpec = {
    httpMethod: "DELETE",
    path: "pushNotifications/applications/{applicationKey}/deviceToken/{deviceToken}",
    urlParameters: [
        Parameters.applicationKey,
        Parameters.deviceToken
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xNotificationCentreApiKey
    ],
    responses: {
        200: {},
        204: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsRealTimeOrderTrackingLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/realTimeOrderTracking/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRecurringPaymentCardsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/recurringPaymentCards",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.onlyActive
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRecurringPaymentCardsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerRecurringPaymentCardOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/recurringPaymentCards/{recurringPaymentCardId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.recurringPaymentCardId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRecurringPaymentCardsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/recurringPaymentCardsMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataRecurringPaymentCardMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionReferralOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/referral",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingReferralDto
        },
        402: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionReferralOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/referral",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingReferralDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingReferralDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerConsultantOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/consultants",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersConsultantRegistrationDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRegistrationResultDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createConsultantOperationSpec = {
    httpMethod: "POST",
    path: "consultants",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersSelfRegistrationDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRegistrationResultDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConsultantsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/consultantsMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataSponsorRegistrationMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getConsultantsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "consultantsMetadata",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataSelfRegistrationMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationOrderOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/registrationOrder",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRegistrationOrderDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerRegistrationOrderOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/registrationOrder",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersRegistrationOrderDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/{registrationId}",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomerRegistrationsRegistrationDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerRegistrationOperationSpec = {
    httpMethod: "PUT",
    path: "customerRegistrations/{registrationId}",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomerRegistrationsRegistrationDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationsCustomerOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/customers/{customerId}",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomerRegistrationsRegistrationDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerRegistrationOperationSpec = {
    httpMethod: "POST",
    path: "customerRegistrations",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomerRegistrationsRegistrationDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getProductRelationsOperationSpec = {
    httpMethod: "GET",
    path: "products/{productCode}/relations",
    urlParameters: [
        Parameters.productCode
    ],
    queryParameters: [
        Parameters.relationTypes
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsRelationsDto
        },
        default: {}
    },
    serializer: serializer
};
var createReportingReportsInstallOperationSpec = {
    httpMethod: "POST",
    path: "reporting/reports/install",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getRequiredTermsOperationSpec = {
    httpMethod: "GET",
    path: "requiredTerms",
    queryParameters: [
        Parameters.termsCustomerType,
        Parameters.termsType
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTermsRequiredTermsDto
        },
        default: {}
    },
    serializer: serializer
};
var createRevolutProfileOperationSpec = {
    httpMethod: "POST",
    path: "revolutProfiles",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalFinanceRevolutProfileDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSalesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sales",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSalesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getSalesmanagoClientDataOperationSpec = {
    httpMethod: "GET",
    path: "salesmanagoClientData",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSalesManagoClientDataSalesManagoClientDataDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionSectionItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/sectionItems",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionItemsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sections",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionSuggestionsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sectionSuggestions",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.code,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionSuggestionsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionWishlistItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionWishlistDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSectionWishlistItemsOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionSectionWishlistOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingSectionWishlistItemDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionWishlistItemDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionWishlistOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionWishlistItemDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionSectionWishlistOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingSectionWishlistItemDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionWishlistItemDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSectionWishlistOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsNetworkCommunicationConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/networkCommunication/configuration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNetworkCommunicationConfigurationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsNetworkCommunicationLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/networkCommunication/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShippingJokerChoiceOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shippingJokerChoice",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShippingJokerChoiceOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shippingJokerChoice",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionShippingJokerChoiceOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/shippingJokerChoice",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShippingChoiceDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShippingJokerChoicesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shippingJokerChoices",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingChoicesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShippingJokerChoicesOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shippingJokerChoices",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionShippingJokerChoicesOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/shippingJokerChoices",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShippingChoicesDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingChoicesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShippingJokersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shippingJokers",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.deliveryChannelId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingJokersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionShoppingBagOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/shoppingBag",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShoppingBagOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shoppingBag",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShoppingBagAggregatedItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shoppingBag/aggregatedItems",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingBagAggregatedItemsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionShoppingBagBagItemOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShoppingBagItemDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShoppingBagBagItemOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShoppingBagBagItemBackorderOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionShoppingBagBagItemBackorderOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShoppingBagBagItemBackorderOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPendingBackordersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/pendingBackorders",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionShoppingBagBagItemOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xReferer,
        Parameters.xPlacement
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShoppingBagItemDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionShoppingBagBagItemsOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xReferer,
        Parameters.xPlacement
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: {
            serializedName: "body",
            type: {
                name: "Sequence",
                element: {
                    type: {
                        name: "Composite",
                        className: "GlobalShoppingShoppingBagItemDto"
                    }
                }
            }
        }
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateApplicationsWechatpbsShoppingSessionShoppingBagBagItemsOperationSpec = {
    httpMethod: "PUT",
    path: "applications/wechatpbs/shoppingSessions/{sessionId}/shoppingBag/bagItems",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: {
            serializedName: "body",
            type: {
                name: "Sequence",
                element: {
                    type: {
                        name: "Composite",
                        className: "GlobalShoppingShoppingBagItemDto"
                    }
                }
            }
        }
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionCampaignPointsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/campaigns/{campaignId}/points",
    urlParameters: [
        Parameters.sessionId,
        Parameters.campaignId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignPointsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionEndConsumerOrdersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/endConsumerOrders",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingEndConsumerOrdersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionEndConsumerOrderOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.endConsumerOrderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionEndConsumerOrderItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items",
    urlParameters: [
        Parameters.sessionId,
        Parameters.endConsumerOrderId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingEndConsumerOrderItemsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionEndConsumerOrderItemOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.endConsumerOrderId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingEndConsumerOrderItemDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingEndConsumerOrderItemDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionEndConsumerOrderItemOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.endConsumerOrderId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionMessagesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/messages",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.type2,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingMessagesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShoppingDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingSessionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingSessionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createApplicationsSocialMediaLibraryCustomerSocialEntityVisitOperationSpec = {
    httpMethod: "POST",
    path: "applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/visit",
    urlParameters: [
        Parameters.customerId0,
        Parameters.entityId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var createApplicationsSocialMediaLibraryCustomerSocialEntityLikeOperationSpec = {
    httpMethod: "POST",
    path: "applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/like",
    urlParameters: [
        Parameters.customerId0,
        Parameters.entityId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var deleteApplicationsSocialMediaLibraryCustomerSocialEntityLikeOperationSpec = {
    httpMethod: "DELETE",
    path: "applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/like",
    urlParameters: [
        Parameters.customerId0,
        Parameters.entityId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSocialMediaLibraryCustomerSocialEntityLikesOperationSpec = {
    httpMethod: "GET",
    path: "applications/socialMediaLibrary/customers/{customerId}/SocialEntityLikes",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSocialMediaLibrarySocialEntitiesCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsSocialMediaLibraryStatsOperationSpec = {
    httpMethod: "GET",
    path: "applications/socialMediaLibrary/stats",
    queryParameters: [
        Parameters.sortType,
        Parameters.sortBy,
        Parameters.take2,
        Parameters.skip1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSocialMediaLibrarySocialEntitiesStatsDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOfferOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOfferChoiceOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/choice",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionSpecialOfferChoiceOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/choice",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingSpecialOfferChoiceDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSpecialOfferChoiceOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/choice",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOfferReplacementsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/replacements",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferReplacementsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOffersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOffersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOfferVoucherOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferVoucherDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionSpecialOfferVoucherChoiceOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher/choices",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingSpecialOfferVoucherChoiceDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSpecialOfferVoucherChoiceOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher/choices/{choiceId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.choiceId,
        Parameters.offerId1
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationSponsorDetailsOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/{registrationId}/sponsorDetails",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomerRegistrationsRegistrationSponsorDetailsDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerRegistrationSponsorDetailsOperationSpec = {
    httpMethod: "PUT",
    path: "customerRegistrations/{registrationId}/sponsorDetails",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomerRegistrationsRegistrationSponsorDetailsDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationSponsorDetailsSponsorInfoOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/{registrationId}/sponsorDetails/sponsorInfo",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomerRegistrationsRegistrationSponsorInfoDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRegistrationSponsorDetailsProfileImageOperationSpec = {
    httpMethod: "GET",
    path: "customerRegistrations/{registrationId}/sponsorDetails/profileImage",
    urlParameters: [
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerSponsorsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/sponsors",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSponsorsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerStepsToSuccessTasksOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/stepsToSuccess",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.top4,
        Parameters.skip2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeStepsToSuccessStepsToSuccessTasksDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerStepsToSuccessTasksPhasesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/stepsToSuccessPhases",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.skip1,
        Parameters.top6
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeStepsToSuccessStepsToSuccessTasksPhasesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerStepsToSuccessTaskOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/stepsToSuccess/{taskId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.taskId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeStepsToSuccessStepsToSuccessTaskDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerStepsToSuccessCompleteOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/stepsToSuccess/{taskId}/complete",
    urlParameters: [
        Parameters.taskId,
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerSubscriptionConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/subscriptionConfiguration",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerSubscriptionAvailabilitiesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/subscriptionAvailabilities",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.products
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerSubscriptionTypesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/subscriptionTypes",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.product
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionTypesDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerSubscriptionInstructionOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/subscriptionInstructions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext,
        Parameters.xReferer,
        Parameters.xPlacement
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersSubscriptionInstructionDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionInstructionDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerSubscriptionsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/subscriptions",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.periodId0,
        Parameters.isAutoship
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionsDto
        },
        default: {}
    },
    serializer: serializer
};
var deleteCustomerSubscriptionOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/subscriptions/{subscriptionId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.subscriptionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerSubscriptionOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/subscriptions/{subscriptionId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.subscriptionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: "body",
        mapper: __assign(__assign({}, Mappers.GlobalCustomersSubscriptionDto), { required: true })
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerSubscriptionSubscriptionItemOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/subscriptions/{subscriptionId}/subscriptionItems/{subscriptionItemId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.subscriptionId,
        Parameters.subscriptionItemId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: "body",
        mapper: __assign(__assign({}, Mappers.GlobalCustomersSubscriptionItemDto), { required: true })
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSubscriptionsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/subscriptions",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSubscriptionsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSubscriptionOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/subscriptions/{subscriptionId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.subscriptionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSubscriptionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSubscriptionOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/subscriptions/{subscriptionId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.subscriptionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSubscriptionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSubscriptionStepsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps",
    urlParameters: [
        Parameters.sessionId,
        Parameters.subscriptionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSubscriptionStepsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSubscriptionStepOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps/{stepNumber}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.subscriptionId,
        Parameters.stepNumber
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSubscriptionStepDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSubscriptionStepOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps/{stepNumber}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.subscriptionId,
        Parameters.stepNumber
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSubscriptionCycleStepOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/cycles/{cycleNumber}/steps/{stepNumber}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.subscriptionId,
        Parameters.cycleNumber,
        Parameters.stepNumber
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSubscriptionWizardLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/subscriptionWizard/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSummaryOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/summary",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingSummaryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSummaryAccountsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/summary/accounts",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSummaryAccountsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSummaryDiscountsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/summary/discounts",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedOrderDiscountsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/categories",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSupportCenterSupportCenterCategoriesDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterCategoryOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/categories/{categoryId}",
    urlParameters: [
        Parameters.categoryId2
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSupportCenterSupportCenterCategoryDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterLocalizationDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterFeaturedFaqsOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/featuredFaqs",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSupportCenterSupportCenterFeaturedFaqsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterSearchOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/search",
    queryParameters: [
        Parameters.query,
        Parameters.skip1,
        Parameters.take3
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSupportCenterSupportCenterSearchResultDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getProductsTagGroupsOperationSpec = {
    httpMethod: "GET",
    path: "products/tagGroups",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTagsTagGroupsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerTaxDocumentOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/taxDocument",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersTaxDocumentDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerTaxDocumentOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/taxDocument",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersTaxDocumentDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerTerminationStatusOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/terminationStatus",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersTerminationStatusDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerTerminationStatusOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/terminationStatus",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersTerminationStatusDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getTermHtmlDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "terms/{termId}/html",
    urlParameters: [
        Parameters.termId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTermsTermHtmlDto
        },
        default: {}
    },
    serializer: serializer
};
var getTestPingOperationSpec = {
    httpMethod: "GET",
    path: "test/ping",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerUpgradeRequestOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/upgradeRequest",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalUpgradeRequestUpgradeRequestDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerUpgradeRequestOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/upgradeRequest",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalUpgradeRequestUpgradeRequestDto
    },
    responses: {
        202: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerUpgradeRequestMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/upgradeRequestMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalUpgradeRequestMetadataUpgradeRequestMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getBusinessToolCustomerSettingOperationSpec = {
    httpMethod: "GET",
    path: "businessTools/{businessToolId}/customerSettings/{customerId}",
    urlParameters: [
        Parameters.businessToolId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConsultantsBusinessToolSettingDto
        },
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteBusinessToolCustomerSettingOperationSpec = {
    httpMethod: "DELETE",
    path: "businessTools/{businessToolId}/customerSettings/{customerId}",
    urlParameters: [
        Parameters.businessToolId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateBusinessToolCustomerSettingOperationSpec = {
    httpMethod: "PUT",
    path: "businessTools/{businessToolId}/customerSettings/{customerId}",
    urlParameters: [
        Parameters.businessToolId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConsultantsBusinessToolActivationDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConsultantsBusinessToolSettingDto
        },
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getSettingsClientSettingCustomerOperationSpec = {
    httpMethod: "GET",
    path: "settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}",
    urlParameters: [
        Parameters.settingsClient,
        Parameters.settingId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConsultantsSettingDto
        },
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateSettingsClientSettingCustomerOperationSpec = {
    httpMethod: "PUT",
    path: "settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}",
    urlParameters: [
        Parameters.settingsClient,
        Parameters.settingId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConsultantsSettingDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConsultantsSettingDto
        },
        400: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var deleteSettingsClientSettingCustomerOperationSpec = {
    httpMethod: "DELETE",
    path: "settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}",
    urlParameters: [
        Parameters.settingsClient,
        Parameters.settingId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerVatDocumentTypeOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/vatDocumentType",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerSelectionDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerVatDocumentTypeOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/vatDocumentType",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerSelectionDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsVideoShoppingLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/videoShopping/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsVideoShoppingConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/videoShopping/configuration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsVideoShoppingConfigurationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerVideoShoppingShowsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/videoShoppingShows",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.showTypes,
        Parameters.current
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersVideoShowsDto
        },
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerVideoShoppingInvitationOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/videoShoppingInvitation",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersVideoShoppingUserInvitationDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerVipCustomerBannerOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/vipCustomerBanner",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsVipCustomerBannerVipCustomerBannerDto
        },
        default: {}
    },
    serializer: serializer
};
var getVipLoyaltyCampaignStepperConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "vipLoyaltyCampaignStepperConfiguration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalVipLoyaltyCampaignStepperConfigurationVipLoyaltyCampaignStepperConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsVipUpgradeLocalizationDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "applications/vipUpgrade/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionVoucherCodesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/voucherCodes",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingVoucherCodesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionVoucherCodesOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/voucherCodes",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionVoucherCodeOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/voucherCodes",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingVoucherCodeDto
    },
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionVoucherCodeOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/voucherCodes/{voucherCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.voucherCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingVoucherCodeDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionVoucherCodeOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/voucherCodes/{voucherCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.voucherCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getVouchersOperationSpec = {
    httpMethod: "GET",
    path: "vouchers",
    queryParameters: [
        Parameters.customerId1,
        Parameters.includeUpcoming
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalVouchersVouchersDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionVouchersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/vouchers",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingVouchersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsVouchersLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/vouchers/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var createApplicationsVideoShoppingAccountUserEventOperationSpec = {
    httpMethod: "POST",
    path: "applications/videoShopping/accounts/{accountId}/userEvents",
    urlParameters: [
        Parameters.accountId
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalApplicationsVideoShoppingUserEventDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var createLoginProvidersWeChatExternalAccountOperationSpec = {
    httpMethod: "POST",
    path: "login/providers/weChat/externalAccount",
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalLoginWeChatAccountDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        default: {}
    },
    serializer: serializer
};
var getLoginProvidersWeChatExternalAccountPlatformsOperationSpec = {
    httpMethod: "GET",
    path: "login/providers/weChat/externalAccount/{unionId}/platforms",
    urlParameters: [
        Parameters.unionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalLoginProvidersWeChatPlatformsDto
        },
        default: {}
    },
    serializer: serializer
};
var createLoginProvidersWeChatExternalAccountPlatformOperationSpec = {
    httpMethod: "POST",
    path: "login/providers/weChat/externalAccount/{unionId}/platforms",
    urlParameters: [
        Parameters.unionId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalLoginProvidersWeChatPlatformDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerWellnessClubsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/wellnessClubs",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.clubTypes,
        Parameters.isMember,
        Parameters.statusTypes
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersWellnessClubsDto
        },
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerWellnessClubTypeWellnessClubOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs",
    urlParameters: [
        Parameters.customerId0,
        Parameters.clubType
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersWellnessClubDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerWellnessClubTypeWellnessClubOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.clubType,
        Parameters.clubId
    ],
    queryParameters: [
        Parameters.statusTypes
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersWellnessClubDetailDto
        },
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerWellnessClubTypeWellnessClubOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.clubType,
        Parameters.clubId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersWellnessClubDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerWellnessClubTypeWellnessClubOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.clubType,
        Parameters.clubId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerWellnessClubTypeWellnessClubMemberOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}/members",
    urlParameters: [
        Parameters.customerId0,
        Parameters.clubType,
        Parameters.clubId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersWellnessClubMemberDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerWellnessClubTypeWellnessClubMemberOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}/members/{memberCustomerId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.clubType,
        Parameters.clubId,
        Parameters.memberCustomerId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerWellnessClubTypeWellnessClubMemberOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}/members/{memberCustomerId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.clubType,
        Parameters.clubId,
        Parameters.memberCustomerId
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersWellnessClubMemberDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateWellnessClubInvitationApprovalOperationSpec = {
    httpMethod: "PUT",
    path: "wellnessClubInvitations/{invitationCode}/approval",
    urlParameters: [
        Parameters.invitationCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersWellnessClubInvitationApprovalDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        default: {}
    },
    serializer: serializer
};
var getWellnessClubInvitationDetailsOperationSpec = {
    httpMethod: "GET",
    path: "wellnessClubInvitations/{invitationCode}/details",
    urlParameters: [
        Parameters.invitationCode
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersWellnessClubDetailDto
        },
        400: {},
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsWellnessClubLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/wellnessClub/localization",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsWellnessClubConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/wellnessClub/configuration",
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsWellnessClubConfigurationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerWellnessLifeOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/wellnessLife",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerBooleanDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerWellnessLifeOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/wellnessLife",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerBooleanDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
export { Api, ApiContext, Models as ApiModels, Mappers as ApiMappers };

//# sourceMappingURL=api.js.map
